"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var RevenueEntry_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosterNote = exports.VacationPolicy = exports.Absence = exports.AbsenceStatus = exports.RosterTargets = exports.RevenuePrediction = exports.RevenueEntry = exports.RevenueGroup = exports.RevenueType = exports.TaxKey = exports.RosterTemplate = exports.PublishedRoster = exports.TimeEntry = exports.timeEntryTypeColor = exports.timeEntryAbsenceTypes = exports.absenceTypes = exports.TimeEntryType = exports.Salary = exports.Contract = exports.Employee = exports.Gender = exports.EmployeeStatus = exports.InviteStatus = exports.Position = exports.Department = exports.Venue = exports.Account = exports.Company = exports.CompanyStatus = exports.BillingInfo = exports.featureFlags = exports.BillingMode = exports.PartnerIntegration = exports.Feature = exports.AccountingSalaryConfig = exports.BonusAccountingSalaryConfig = exports.AbsenceAccountingSalaryConfig = exports.CompanySettings = exports.StaffAppFeature = exports.defaultNotificationSettings = exports.AccountingSettings = exports.TimeSettings = exports.MealsMode = exports.AbsenceMode = exports.BreakTiming = exports.BreakMode = exports.VacationIncrement = exports.EmploymentType = exports.NominalHoursMode = exports.Role = void 0;
exports.Note = exports.noteTypes = exports.TimeLogEvent = exports.TimeLogDevice = exports.AccountingSalaryConfigBenefit = exports.Benefit = exports.BenefitType = exports.AccountingSalaryConfigBonus = exports.Bonus = exports.BonusType = exports.BonusCompType = exports.BonusLegalType = exports.BonusTypeOverride = exports.BonusTypeMode = exports.JobApplication = exports.JobPosting = exports.DocumentTag = exports.Document = exports.MimeType = exports.Form = exports.FormStatus = exports.Availability = exports.Repeat = exports.AvailabilityStatus = exports.CompanyLifeCycleEvent = exports.GetEmployeeStatementsParams = void 0;
exports.breakModeLabel = breakModeLabel;
exports.employmentTypeLabel = employmentTypeLabel;
exports.employmentTypeDescription = employmentTypeDescription;
exports.employmentTypeColor = employmentTypeColor;
exports.getEmploymentTypeGroup = getEmploymentTypeGroup;
exports.getEmploymentTypes = getEmploymentTypes;
exports.staffAppFeatureLabel = staffAppFeatureLabel;
exports.employeeStatusLabel = employeeStatusLabel;
exports.employeeStatusColor = employeeStatusColor;
exports.employeeStatusIcon = employeeStatusIcon;
exports.genderLabel = genderLabel;
exports.companyStatusColor = companyStatusColor;
exports.companyStatusLabel = companyStatusLabel;
exports.availabilityColor = availabilityColor;
exports.availabilityLabel = availabilityLabel;
exports.availabilityIcon = availabilityIcon;
exports.repeatsLabel = repeatsLabel;
exports.taxKeyLabel = taxKeyLabel;
exports.taxKeyValue = taxKeyValue;
exports.revenueTypeLabel = revenueTypeLabel;
exports.revenueTypeIcon = revenueTypeIcon;
exports.formStatusColor = formStatusColor;
exports.formStatusLabel = formStatusLabel;
exports.fileIcon = fileIcon;
exports.fileExtension = fileExtension;
exports.timeLogActionLabel = timeLogActionLabel;
exports.timeLogActionIcon = timeLogActionIcon;
exports.stripSensitiveData = stripSensitiveData;
exports.stripSensitiveDataForManageApp = stripSensitiveDataForManageApp;
const utils_1 = require("./utils");
const typeorm_1 = require("typeorm");
const class_transformer_1 = require("class-transformer");
const colors_1 = require("./colors");
const holidays_1 = require("./holidays");
const filters_1 = require("./filters");
const encoding_1 = require("./encoding");
const time_1 = require("./time");
const openapi_1 = require("@pentacode/openapi");
const localized_1 = require("./localized");
const invoice_1 = require("./invoice");
const lifecycle_events_1 = require("./lifecycle-events");
const time_entry_type_1 = require("./time-entries/time-entry-type");
const contract_util_1 = require("./contract.util");
const entities_1 = require("./entities");
var Role;
(function (Role) {
    Role[Role["Admin"] = -1] = "Admin";
    Role[Role["Owner"] = 0] = "Owner";
    Role[Role["Manager"] = 1] = "Manager";
    Role[Role["Worker"] = 2] = "Worker";
})(Role || (exports.Role = Role = {}));
function breakModeLabel(mode) {
    switch (mode) {
        case BreakMode.Auto:
            return "Automatisch";
        case BreakMode.Manual:
            return "Manuell";
        case BreakMode.AutoPlusManual:
            return "Automatisch + Manuell";
        case BreakMode.Planned:
            return "Geplant";
        case BreakMode.PlannedPlusManual:
            return "Geplant + Manuell";
        case BreakMode.AutoOrManual:
            return "Automatisch oder Manuell";
        case BreakMode.PlannedOrManual:
            return "Geplant oder Manuell";
    }
}
var NominalHoursMode;
(function (NominalHoursMode) {
    NominalHoursMode[NominalHoursMode["WeekFactor"] = 0] = "WeekFactor";
    NominalHoursMode[NominalHoursMode["Exact"] = 1] = "Exact";
    NominalHoursMode[NominalHoursMode["ExactWithoutHolidays"] = 2] = "ExactWithoutHolidays";
    NominalHoursMode[NominalHoursMode["FixedDays"] = 3] = "FixedDays";
    NominalHoursMode[NominalHoursMode["FixedDaysWithoutHolidays"] = 4] = "FixedDaysWithoutHolidays";
    NominalHoursMode[NominalHoursMode["ExactWithoutHolidaysUsingAbsenceHours"] = 5] = "ExactWithoutHolidaysUsingAbsenceHours";
})(NominalHoursMode || (exports.NominalHoursMode = NominalHoursMode = {}));
var EmploymentType;
(function (EmploymentType) {
    EmploymentType[EmploymentType["Regular"] = 0] = "Regular";
    EmploymentType[EmploymentType["Marginal"] = 1] = "Marginal";
    EmploymentType[EmploymentType["Independent"] = 2] = "Independent";
    EmploymentType[EmploymentType["ShortTerm"] = 3] = "ShortTerm";
    EmploymentType[EmploymentType["Trainee"] = 4] = "Trainee";
    EmploymentType[EmploymentType["MidiJob"] = 5] = "MidiJob";
    EmploymentType[EmploymentType["WorkingStudent"] = 6] = "WorkingStudent";
    EmploymentType[EmploymentType["DualStudent"] = 7] = "DualStudent";
    EmploymentType[EmploymentType["Intern"] = 8] = "Intern";
})(EmploymentType || (exports.EmploymentType = EmploymentType = {}));
function employmentTypeLabel(type, full = false) {
    return full
        ? [
            "Vollzeit/Teilzeit",
            "Aushilfe",
            "Freier Mitarbeiter",
            "Kurzfristig Beschäftigt",
            "Auszubildender",
            "Midi-Job",
            "Werkstudent",
            "Dualer Student",
            "Praktikant",
        ][type]
        : [
            "VZ/TZ",
            "Aushilfe",
            "Fr. Mitarb.",
            "Kurzfr. Besch.",
            "Azubi",
            "Midi-Job",
            "Werkstudent",
            "Dualer Stud.",
            "Praktikant",
        ][type];
}
function employmentTypeDescription(type) {
    switch (type) {
        case EmploymentType.Regular:
            return "Der Mitarbeiter ist normal angestellt und bezieht ein monatliches oder stündliches Gehalt.";
        case EmploymentType.Marginal:
            return "Der Mitarbeiter ist geringfügig beschäftigt und darf nicht mehr als 556 € im Monat verdienen.";
        case EmploymentType.Independent:
            return "Der Mitarbeiter ist auf selbständiger Basis tätig und schreibt Rechnungen.";
        case EmploymentType.ShortTerm:
            return "Kurzfristige Beschäftigte und Saisonarbeiter dürfen nicht mehr als 70 Tage / Jahr beschäftigt werden.";
        case EmploymentType.Trainee:
            return "Bei Auszubildenden ist die Mindestlohn-Überprüfung ausgesetzt. Ansonsten gelten altersunabhängig die Standardregeln für Festangestellte.";
        case EmploymentType.MidiJob:
            return "Ein Midi-Job ist eine geringfügige Beschäftigung mit einem monatlichen Arbeitsentgeld zwischen 556,01 € und 2000 €. Midijobber sind versicherungspflichtig und dürfen maximal 155,9 Stunden im Monat arbeiten.";
        case EmploymentType.WorkingStudent:
            return "Werkstudenten sind an einer Fach- oder Hochschule Studierende, die neben dem Studium einer geringfügigen Beschäftigung nachgehen. Werkstudenten dürfen höchsten 20 Stunden pro Woche während der Vorlesungszeit und insgesamt nicht mehr als 26 Wochen im Jahr arbeiten.";
        case EmploymentType.DualStudent:
            return "Duales Studenten sind an einer Hochschule Studierende, die ihr Studium mit Praxiserfahrung in einem Unternehmen kombinieren. Im Gegensatz zu Werkstudenten sind duale Studenten voll sozialversicherungspflichtig und es gibt keine besonderen Einschränkungen der Arbeitszeit.";
        case EmploymentType.Intern:
            return "Praktikanten sind Personen, die eine in Studien- oder Prüfungsordnungen vorgeschriebene berufspraktische Tätigkeit im Rahmen eines Praktikums verrichten.";
        default:
            return "";
    }
}
function employmentTypeColor(type) {
    switch (type) {
        case EmploymentType.Regular:
            return colors_1.colors.blue;
        case EmploymentType.Marginal:
            return colors_1.colors.orange;
        case EmploymentType.Independent:
            return colors_1.colors.violet;
        case EmploymentType.ShortTerm:
            return colors_1.colors.green;
        case EmploymentType.Trainee:
            return colors_1.colors.yellow;
        case EmploymentType.MidiJob:
            return colors_1.colors.purple;
        case EmploymentType.WorkingStudent:
            return colors_1.colors.teal;
        case EmploymentType.DualStudent:
            return colors_1.colors.red;
        case EmploymentType.Intern:
            return colors_1.colors.pink;
        default:
            return "";
    }
}
function getEmploymentTypeGroup(type) {
    switch (type) {
        case EmploymentType.Regular:
            return "101";
        case EmploymentType.Marginal:
            return "109";
        case EmploymentType.ShortTerm:
            return "110";
        case EmploymentType.Trainee:
            return "121";
        case EmploymentType.MidiJob:
            return "";
        case EmploymentType.WorkingStudent:
            return "106";
        case EmploymentType.DualStudent:
            return "102";
        case EmploymentType.Intern:
            return "105";
        case EmploymentType.Independent:
            return "";
        default:
            return "";
    }
}
function getEmploymentTypes() {
    return Object.values(EmploymentType)
        .filter((t) => typeof t === "number")
        .map((type) => ({
        type,
        label: employmentTypeLabel(type, true),
        labelShort: employmentTypeLabel(type),
        description: employmentTypeDescription(type),
        color: employmentTypeColor(type),
    }));
}
var VacationIncrement;
(function (VacationIncrement) {
    VacationIncrement[VacationIncrement["Monthly"] = 0] = "Monthly";
    VacationIncrement[VacationIncrement["Hourly"] = 1] = "Hourly";
})(VacationIncrement || (exports.VacationIncrement = VacationIncrement = {}));
/**
 * Specifies how breaks are handled for a given shift.
 *
 * See also {@link TimeSettings}, {@link AutoBreak}
 */
//TODO: move to breaks.ts
var BreakMode;
(function (BreakMode) {
    /** Breaks are calculated according to {@link TimeSettings.autoBreaks} */
    BreakMode[BreakMode["Auto"] = 0] = "Auto";
    /** Breaks are taken directly from time entries */
    BreakMode[BreakMode["Manual"] = 1] = "Manual";
    /** Breaks are calculated by adding manual breaks to automatic breaks */
    BreakMode[BreakMode["AutoPlusManual"] = 2] = "AutoPlusManual";
    /** Breaks are planned as part of a shift */
    BreakMode[BreakMode["Planned"] = 3] = "Planned";
    /** Breaks are calculated by adding manual breaks to planned breaks */
    BreakMode[BreakMode["PlannedPlusManual"] = 4] = "PlannedPlusManual";
    /** Breaks are the maximum of automatic and manual breaks */
    BreakMode[BreakMode["AutoOrManual"] = 5] = "AutoOrManual";
    /** Breaks are the maximum of planned and manual breaks */
    BreakMode[BreakMode["PlannedOrManual"] = 6] = "PlannedOrManual";
})(BreakMode || (exports.BreakMode = BreakMode = {}));
/**
 * Specifies whether a break is deducted from the start or the end of a shift.
 */
//TODO: move to breaks.ts
var BreakTiming;
(function (BreakTiming) {
    BreakTiming["Start"] = "start";
    BreakTiming["End"] = "end";
})(BreakTiming || (exports.BreakTiming = BreakTiming = {}));
const defaultAutoBreaks = [
    { duration: 6, amount: 0.5 },
    { duration: 9, amount: 0.75 },
];
var AbsenceMode;
(function (AbsenceMode) {
    AbsenceMode[AbsenceMode["Average"] = 0] = "Average";
    AbsenceMode[AbsenceMode["Fixed"] = 1] = "Fixed";
    AbsenceMode[AbsenceMode["FixedDays"] = 2] = "FixedDays";
})(AbsenceMode || (exports.AbsenceMode = AbsenceMode = {}));
var MealsMode;
(function (MealsMode) {
    MealsMode["Manual"] = "manual";
    MealsMode["Auto"] = "auto";
    MealsMode["Employee"] = "employee";
})(MealsMode || (exports.MealsMode = MealsMode = {}));
let TimeSettings = class TimeSettings {
    constructor(vals = {}) {
        this.trackingEnabled = true;
        this.applyEarlyCheckin = false;
        this.applyLateCheckout = false;
        this.checkinWindow = 0.5;
        this.checkoutWindow = 11;
        this.checkinRounding = 5;
        this.checkoutRounding = -5;
        this.breakMode = BreakMode.Auto;
        this.breakTiming = BreakTiming.Start;
        this.unplannedCheckins = true;
        this.trackerDisplayEmployeeInfo = false;
        this.trackerDisplayRoster = true;
        this.trackerDisplayShiftDetails = false;
        /** @deprecated as of v1.25.0 */
        this.autoMeals = 0;
        this.mealsMode = MealsMode.Manual;
        this.mealEnabledBreakfast = false;
        this.mealStartBreakfast = null;
        this.mealEndBreakfast = null;
        this.mealEnabledLunch = true;
        this.mealStartLunch = "00:00:00";
        this.mealEndLunch = "24:00:00";
        this.mealEnabledDinner = false;
        this.mealStartDinner = null;
        this.mealEndDinner = null;
        this.mealsMinDuration = 0;
        this.autoBreaks = defaultAutoBreaks;
        this.paidBreaksAuto = false;
        this.paidBreaksManual = false;
        this.trackingViaAppEnabled = false;
        this.trackingViaAppRequiresToken = true;
        this.loggingRequiresPhotoFor = [];
        this.loggingRequiresLocation = false;
        this.order = 0;
        this.filters = [];
        /** @deprecated */
        this.bonusNight1Start = "20:00:00";
        /** @deprecated */
        this.bonusNight1End = "06:00:00";
        /** @deprecated */
        this.bonusNight2Start = "00:00:00";
        /** @deprecated */
        this.bonusNight2End = "04:00:00";
        /** @deprecated */
        this.bonusMinDuration = 0;
        /** @deprecated */
        this.bonusSundayNextDayUntil = "04:00:00";
        /* @deprecated */
        this.bonusHolidayNextDayUntil = "04:00:00";
        /* @deprecated */
        this.bonusChristmasEveFrom = "14:00:00";
        /* @deprecated */
        this.bonusNewYearsEveFrom = "14:00:00";
        Object.assign(this, vals);
    }
    getBreakfastInterval(date = (0, utils_1.toDateString)(new Date())) {
        return (this.mealEnabledBreakfast &&
            this.mealStartBreakfast &&
            this.mealEnabledBreakfast &&
            (0, utils_1.parseTimes)(date, this.mealStartBreakfast, this.mealEndBreakfast));
    }
    getLunchInterval(date = (0, utils_1.toDateString)(new Date())) {
        return (this.mealEnabledLunch &&
            this.mealStartLunch &&
            this.mealEnabledLunch &&
            (0, utils_1.parseTimes)(date, this.mealStartLunch, this.mealEndLunch));
    }
    getDinnerInterval(date = (0, utils_1.toDateString)(new Date())) {
        return (this.mealEnabledDinner &&
            this.mealStartDinner &&
            this.mealEnabledDinner &&
            (0, utils_1.parseTimes)(date, this.mealStartDinner, this.mealEndDinner));
    }
};
exports.TimeSettings = TimeSettings;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], TimeSettings.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)("CompanySettings", "availableSettings", { eager: false })
    // to avoid cyclical dependencies
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    __metadata("design:type", Object)
], TimeSettings.prototype, "companySettings", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], TimeSettings.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], TimeSettings.prototype, "companySettingsId", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackingEnabled", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "applyEarlyCheckin", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "applyLateCheckout", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0.5 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "checkinWindow", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 11 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "checkoutWindow", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 5 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "checkinRounding", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: -5 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "checkoutRounding", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: BreakMode.Auto }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "breakMode", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: BreakTiming.Start }),
    __metadata("design:type", String)
], TimeSettings.prototype, "breakTiming", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "unplannedCheckins", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackerDisplayEmployeeInfo", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackerDisplayRoster", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackerDisplayShiftDetails", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "autoMeals", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: MealsMode.Manual }),
    __metadata("design:type", String)
], TimeSettings.prototype, "mealsMode", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "mealEnabledBreakfast", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true, default: null }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealStartBreakfast", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true, default: null }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealEndBreakfast", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "mealEnabledLunch", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true, default: "00:00:00" }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealStartLunch", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true, default: "24:00:00" }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealEndLunch", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "mealEnabledDinner", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true, default: null }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealStartDinner", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true, default: null }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealEndDinner", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "mealsMinDuration", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-json", { default: JSON.stringify(defaultAutoBreaks) }),
    __metadata("design:type", Array)
], TimeSettings.prototype, "autoBreaks", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "paidBreaksAuto", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "paidBreaksManual", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackingViaAppEnabled", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackingViaAppRequiresToken", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], TimeSettings.prototype, "loggingRequiresPhotoFor", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "loggingRequiresLocation", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "extractedFromCompany", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "extractedFromVenue", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "extractedFromDepartment", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "extractedFromEmployee", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "order", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], TimeSettings.prototype, "filters", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { default: "20:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusNight1Start", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { default: "06:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusNight1End", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { default: "00:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusNight2Start", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { default: "04:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusNight2End", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "bonusMinDuration", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { default: "04:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusSundayNextDayUntil", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { default: "04:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusHolidayNextDayUntil", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { default: "14:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusChristmasEveFrom", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { default: "14:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusNewYearsEveFrom", void 0);
exports.TimeSettings = TimeSettings = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], TimeSettings);
class AccountingSettings {
    constructor(vals = {}) {
        this.client = "";
        this.consultant = "";
        this.cashbookLedger = "1600";
        this.realAccountsLength = 4;
        this.companyNumber = "";
        Object.assign(this, vals);
    }
}
exports.AccountingSettings = AccountingSettings;
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSettings.prototype, "client", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSettings.prototype, "consultant", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "1600" }),
    __metadata("design:type", String)
], AccountingSettings.prototype, "cashbookLedger", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 4 }),
    __metadata("design:type", Number)
], AccountingSettings.prototype, "realAccountsLength", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSettings.prototype, "companyNumber", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AccountingSalaryConfig),
    (0, typeorm_1.OneToMany)(() => AccountingSalaryConfig, (v) => v.settings, { eager: true, cascade: true }),
    __metadata("design:type", Array)
], AccountingSettings.prototype, "salaryConfigs", void 0);
exports.defaultNotificationSettings = {
    vacationRequests: { email: true, pushDesktop: true, pushMobile: true, filters: [] },
    sickNotes: { email: true, pushDesktop: true, pushMobile: true, filters: [] },
};
var StaffAppFeature;
(function (StaffAppFeature) {
    StaffAppFeature["Roster"] = "roster";
    StaffAppFeature["Absences"] = "absences";
    StaffAppFeature["Ledgers"] = "ledgers";
    StaffAppFeature["Time"] = "time";
    StaffAppFeature["Tracking"] = "tracking";
})(StaffAppFeature || (exports.StaffAppFeature = StaffAppFeature = {}));
function staffAppFeatureLabel(feature) {
    switch (feature) {
        case StaffAppFeature.Roster:
            return "Dienstplan";
        case StaffAppFeature.Absences:
            return "Abwesenheiten";
        case StaffAppFeature.Ledgers:
            return "Konten";
        case StaffAppFeature.Time:
            return "Arbeitszeiten";
        case StaffAppFeature.Tracking:
            return "Stempeluhr";
    }
}
let CompanySettings = class CompanySettings {
    constructor(vals = {}) {
        this.startPayrollPeriod = 1;
        this.nominalHoursMode = NominalHoursMode.WeekFactor;
        this.iterativeBreaks = false;
        this.includeTaxedBonusesInBalance = false;
        this.weekFactor = 4.35;
        this.mealValueBreakfast = null;
        this.mealValueLunch = null;
        this.mealValueDinner = null;
        Object.assign(this, vals);
    }
};
exports.CompanySettings = CompanySettings;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], CompanySettings.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => TimeSettings),
    (0, typeorm_1.OneToOne)(() => TimeSettings, { nullable: true, cascade: false, eager: true, onDelete: "SET NULL" }),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", TimeSettings)
], CompanySettings.prototype, "time", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Number)
], CompanySettings.prototype, "timeId", void 0);
__decorate([
    (0, typeorm_1.Column)(() => AccountingSettings),
    __metadata("design:type", AccountingSettings)
], CompanySettings.prototype, "accounting", void 0);
__decorate([
    (0, typeorm_1.Column)("date", { nullable: true }),
    __metadata("design:type", Object)
], CompanySettings.prototype, "startLedgers", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 1 }),
    __metadata("design:type", Number)
], CompanySettings.prototype, "startPayrollPeriod", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: NominalHoursMode.WeekFactor }),
    __metadata("design:type", Number)
], CompanySettings.prototype, "nominalHoursMode", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], CompanySettings.prototype, "iterativeBreaks", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], CompanySettings.prototype, "includeTaxedBonusesInBalance", void 0);
__decorate([
    (0, typeorm_1.Column)("date", { default: "2021-01-01" }),
    __metadata("design:type", String)
], CompanySettings.prototype, "startUsingDailyAverage", void 0);
__decorate([
    (0, typeorm_1.Column)("date", { default: "2022-01-01" }),
    __metadata("design:type", String)
], CompanySettings.prototype, "startUsingMoreAccurateAverage", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => TimeSettings, (s) => s.companySettings, { eager: true }),
    (0, class_transformer_1.Type)(() => TimeSettings),
    __metadata("design:type", Array)
], CompanySettings.prototype, "availableTimeSettings", void 0);
__decorate([
    (0, typeorm_1.Column)("date", { nullable: true, default: null }),
    __metadata("design:type", Object)
], CompanySettings.prototype, "commitTimeEntriesBefore", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 4.35 }),
    __metadata("design:type", Number)
], CompanySettings.prototype, "weekFactor", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true, default: 2 }),
    __metadata("design:type", Object)
], CompanySettings.prototype, "mealValueBreakfast", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true, default: 3.8 }),
    __metadata("design:type", Object)
], CompanySettings.prototype, "mealValueLunch", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true, default: 3.8 }),
    __metadata("design:type", Object)
], CompanySettings.prototype, "mealValueDinner", void 0);
exports.CompanySettings = CompanySettings = __decorate([
    (0, typeorm_1.Entity)()
    /**
     * @class CompanySettings
     */
    ,
    __metadata("design:paramtypes", [Object])
], CompanySettings);
class AbsenceAccountingSalaryConfig {
    constructor(vals = {}) {
        this.vacation = "";
        this.compDay = "";
        this.sick = "";
        this.childSick = "";
        this.sickInKUG = "";
        Object.assign(this, vals);
    }
}
exports.AbsenceAccountingSalaryConfig = AbsenceAccountingSalaryConfig;
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AbsenceAccountingSalaryConfig.prototype, "vacation", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AbsenceAccountingSalaryConfig.prototype, "compDay", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AbsenceAccountingSalaryConfig.prototype, "sick", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AbsenceAccountingSalaryConfig.prototype, "childSick", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AbsenceAccountingSalaryConfig.prototype, "sickInKUG", void 0);
class BonusAccountingSalaryConfig {
    constructor(vals = {}) {
        this.night1 = "";
        this.night2 = "";
        this.sunday = "";
        this.holiday = "";
        this.special = "";
        Object.assign(this, vals);
    }
}
exports.BonusAccountingSalaryConfig = BonusAccountingSalaryConfig;
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], BonusAccountingSalaryConfig.prototype, "night1", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], BonusAccountingSalaryConfig.prototype, "night2", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], BonusAccountingSalaryConfig.prototype, "sunday", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], BonusAccountingSalaryConfig.prototype, "holiday", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], BonusAccountingSalaryConfig.prototype, "special", void 0);
let AccountingSalaryConfig = class AccountingSalaryConfig {
    constructor(vals = {}) {
        this.name = "";
        this.workHourly = "";
        this.workHourlyDays = "";
        this.workMonthly = "";
        this.workMonthlyDays = "";
        this.overtimeHourly = "";
        this.overtimeMonthly = "";
        this.absenceHourly = new AbsenceAccountingSalaryConfig();
        this.absenceHourlyDays = new AbsenceAccountingSalaryConfig();
        this.absenceMonthly = new AbsenceAccountingSalaryConfig();
        this.absenceMonthlyDays = new AbsenceAccountingSalaryConfig();
        /** @deprecated */
        this.bonusTaxFree = new BonusAccountingSalaryConfig();
        /** @deprecated */
        this.bonusTaxed = new BonusAccountingSalaryConfig();
        this.commission = "";
        this.bonusAdvance = "";
        this.salary = "";
        this.payAdvance = "";
        this.employmentTypes = [];
        this.order = 0;
        this.mealsValue = "";
        this.mealsBreakfast = "";
        this.mealsLunch = "";
        this.mealsDinner = "";
        Object.assign(this, vals);
    }
};
exports.AccountingSalaryConfig = AccountingSalaryConfig;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], AccountingSalaryConfig.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => CompanySettings),
    (0, typeorm_1.ManyToOne)(() => CompanySettings),
    __metadata("design:type", CompanySettings)
], AccountingSalaryConfig.prototype, "settings", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "workHourly", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "workHourlyDays", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "workMonthly", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "workMonthlyDays", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "overtimeHourly", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "overtimeMonthly", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AbsenceAccountingSalaryConfig),
    (0, typeorm_1.Column)(() => AbsenceAccountingSalaryConfig),
    __metadata("design:type", AbsenceAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "absenceHourly", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AbsenceAccountingSalaryConfig),
    (0, typeorm_1.Column)(() => AbsenceAccountingSalaryConfig),
    __metadata("design:type", AbsenceAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "absenceHourlyDays", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AbsenceAccountingSalaryConfig),
    (0, typeorm_1.Column)(() => AbsenceAccountingSalaryConfig),
    __metadata("design:type", AbsenceAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "absenceMonthly", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AbsenceAccountingSalaryConfig),
    (0, typeorm_1.Column)(() => AbsenceAccountingSalaryConfig),
    __metadata("design:type", AbsenceAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "absenceMonthlyDays", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => BonusAccountingSalaryConfig),
    (0, typeorm_1.Column)(() => BonusAccountingSalaryConfig),
    __metadata("design:type", BonusAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "bonusTaxFree", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => BonusAccountingSalaryConfig),
    (0, typeorm_1.Column)(() => BonusAccountingSalaryConfig),
    __metadata("design:type", BonusAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "bonusTaxed", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "commission", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "bonusAdvance", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "salary", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "payAdvance", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-array"),
    __metadata("design:type", Array)
], AccountingSalaryConfig.prototype, "employmentTypes", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { default: [] }),
    __metadata("design:type", Array)
], AccountingSalaryConfig.prototype, "entities", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], AccountingSalaryConfig.prototype, "order", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => AccountingSalaryConfigBonus, (bonus) => bonus.accountingSalaryConfig, {
        eager: true,
        cascade: true,
    }),
    __metadata("design:type", Array)
], AccountingSalaryConfig.prototype, "bonuses", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => AccountingSalaryConfigBenefit, (benefit) => benefit.accountingSalaryConfig, {
        eager: true,
        cascade: true,
    }),
    __metadata("design:type", Array)
], AccountingSalaryConfig.prototype, "benefits", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "mealsValue", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "mealsBreakfast", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "mealsLunch", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "mealsDinner", void 0);
exports.AccountingSalaryConfig = AccountingSalaryConfig = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], AccountingSalaryConfig);
var Feature;
(function (Feature) {
    Feature["Employees"] = "employees";
    Feature["Roster"] = "roster";
    Feature["Time"] = "time";
    Feature["Revenues"] = "revenues";
    Feature["Planning"] = "planning";
    Feature["StaffApp"] = "staffapp";
})(Feature || (exports.Feature = Feature = {}));
var PartnerIntegration;
(function (PartnerIntegration) {
    PartnerIntegration["HorecaHero"] = "horeca_hero";
    PartnerIntegration["Intratool"] = "intratool";
    PartnerIntegration["Onboard"] = "onboard";
    PartnerIntegration["Uberblick"] = "uberblick";
})(PartnerIntegration || (exports.PartnerIntegration = PartnerIntegration = {}));
var BillingMode;
(function (BillingMode) {
    BillingMode["Legacy"] = "legacy";
    BillingMode["Default"] = "default";
    BillingMode["Hogast"] = "hogast";
})(BillingMode || (exports.BillingMode = BillingMode = {}));
exports.featureFlags = [
    "notificationsPushMobile", //TODO: remove
    "notificationsPushDesktop", //TODO: remove
    "rosterAutoAssign",
    "featureVoting",
    "darkMode",
    "pushNotifications",
    "dashboard",
    "pentacodePayroll",
    "nominalHoursModeUsingAbsences",
];
let BillingInfo = class BillingInfo {
    constructor(vals = {}) {
        this.billingMode = BillingMode.Default;
        this.hogastUnionId = null;
        this.hogastMemberId = null;
        this.customer = null;
        this.paymentMethods = [];
        this.invoices = [];
        Object.assign(this, vals);
    }
    get info() {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!this.customer) {
            return {
                name: "",
                email: "",
                phone: "",
                comments: "",
                addressLine1: "",
                addressLine2: "",
                postalCode: "",
                city: "",
                vatId: "",
                billingMode: this.billingMode,
                hogastUnionId: this.hogastUnionId,
                hogastMemberId: this.hogastMemberId,
            };
        }
        return {
            name: this.customer.name || "",
            email: this.customer.email || "",
            phone: this.customer.phone || "",
            comments: this.customer.description || "",
            addressLine1: ((_a = this.customer.address) === null || _a === void 0 ? void 0 : _a.line1) || "",
            addressLine2: ((_b = this.customer.address) === null || _b === void 0 ? void 0 : _b.line2) || "",
            postalCode: ((_c = this.customer.address) === null || _c === void 0 ? void 0 : _c.postal_code) || "",
            city: ((_d = this.customer.address) === null || _d === void 0 ? void 0 : _d.city) || "",
            vatId: ((_g = (_f = (_e = this.customer.tax_ids) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.value) || "",
            billingMode: this.billingMode,
            hogastUnionId: this.hogastUnionId,
            hogastMemberId: this.hogastMemberId,
        };
    }
};
exports.BillingInfo = BillingInfo;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], BillingInfo.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: BillingMode.Default }),
    __metadata("design:type", String)
], BillingInfo.prototype, "billingMode", void 0);
__decorate([
    (0, typeorm_1.Column)("text", { nullable: true }),
    __metadata("design:type", Object)
], BillingInfo.prototype, "hogastUnionId", void 0);
__decorate([
    (0, typeorm_1.Column)("text", { nullable: true }),
    __metadata("design:type", Object)
], BillingInfo.prototype, "hogastMemberId", void 0);
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", String)
], BillingInfo.prototype, "customerId", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], BillingInfo.prototype, "customer", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], BillingInfo.prototype, "paymentMethods", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => invoice_1.Invoice),
    (0, typeorm_1.Column)("jsonb", {
        default: "[]",
        transformer: {
            to: (invoices) => {
                if (!invoices)
                    return [];
                return invoices.map(({ raw, creditNotes }) => ({ raw, creditNotes }));
            },
            from: (rawInvoices) => {
                if (!rawInvoices)
                    return [];
                return rawInvoices.map(({ raw, creditNotes }) => new invoice_1.Invoice(raw, undefined, creditNotes));
            },
        },
    }),
    __metadata("design:type", Array)
], BillingInfo.prototype, "invoices", void 0);
exports.BillingInfo = BillingInfo = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], BillingInfo);
var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus["Trialing"] = "trialing";
    CompanyStatus["Probation"] = "probation";
    CompanyStatus["Active"] = "active";
    CompanyStatus["Paused"] = "paused";
    CompanyStatus["Canceled"] = "canceled";
    CompanyStatus["PaymentOverdue"] = "payment_overdue";
})(CompanyStatus || (exports.CompanyStatus = CompanyStatus = {}));
let Company = class Company {
    constructor(vals = {}) {
        this.name = "";
        this.address = "";
        this.city = "";
        this.postalCode = "";
        this.email = "";
        this.phone = "";
        this.archivedVenues = [];
        this.features = [Feature.Employees, Feature.Roster, Feature.Time];
        this.partnerIntegrations = [];
        this.isBetaCustomer = false;
        this.owner = undefined;
        this.billing = null;
        this.comments = "";
        this.wageTypes = [];
        Object.assign(this, vals);
    }
    get effectiveStatus() {
        const events = (0, lifecycle_events_1.sortLifeCycleEvents)(this.lifeCycleEvents || []);
        const pastEventsWithStatus = events === null || events === void 0 ? void 0 : events.filter((e) => !!e.status && e.date <= (0, utils_1.toDateString)(new Date()));
        return (pastEventsWithStatus === null || pastEventsWithStatus === void 0 ? void 0 : pastEventsWithStatus.length) > 0 ? pastEventsWithStatus.reverse()[0].status : this.status;
    }
    getTimeSettings(context = {}) {
        const ctx = { ...context, company: this };
        return (this.settings.availableTimeSettings
            .sort((a, b) => (0, filters_1.getSpecificity)(b.filters) - (0, filters_1.getSpecificity)(a.filters))
            .find((s) => (0, filters_1.matchesFilters)(s.filters, ctx)) || new TimeSettings());
    }
    getVenue(venueId) {
        return (0, utils_1.getVenue)([...this.venues, ...this.archivedVenues], venueId);
    }
    getDepartment(id) {
        return (0, utils_1.getDepartment)([...this.venues, ...this.archivedVenues], id);
    }
    getPositionColor(position) {
        return (0, utils_1.getPositionColor)([...this.venues, ...this.archivedVenues], position);
    }
    getTimeEntryColor(entry) {
        var _a;
        const position = entry.positionId ? (_a = this.getPosition(entry.positionId)) === null || _a === void 0 ? void 0 : _a.position : null;
        if (position) {
            return this.getPositionColor(position);
        }
        else {
            return (0, time_entry_type_1.timeEntryTypeColor)(entry.type);
        }
    }
    getTimeEntryTypeLabel(entry) {
        return entry.position ? entry.position.name : localized_1.Localized[this.country].timeEntryTypeLabel(entry.type);
    }
    getPositionLabel(pos) {
        var _a;
        const position = typeof pos === "number" ? (_a = this.getPosition(pos)) === null || _a === void 0 ? void 0 : _a.position : pos;
        if (!position) {
            return null;
        }
        const { venue, department } = this.getDepartment(position.departmentId);
        if (!venue || !department) {
            return position.name;
        }
        let label = `${department.name} / ${position.name}`;
        if (this.venues.length > 1) {
            label = `${venue.name} / ${label}`;
        }
        return label;
    }
    getPosition(id) {
        return (0, utils_1.getPosition)(this.venues, this.archivedVenues, id);
    }
    getEmployee(id) {
        return (0, utils_1.findEmployeeById)(this.employees, id);
    }
    getEmployeeByStaffNumber(staffNumber) {
        return (0, utils_1.findEmployeeByStaffNumber)(this.employees, staffNumber);
    }
    isOwner(account) {
        const employee = this.employees.find((e) => e.accountId === account.id);
        return !!employee && employee.role === Role.Owner;
    }
    hasAccess(employee, context) {
        var _a;
        return (employee.role <= Role.Owner || (0, filters_1.matchesFilters)(((_a = employee.access) === null || _a === void 0 ? void 0 : _a.filters) || [], { company: this, ...context }));
    }
    hasPermission(account, scope) {
        if (account.admin) {
            return true;
        }
        const employee = this.employees.find((e) => e.accountId === account.id);
        return !!employee && employee.hasPermission(scope);
    }
    getCostCenterForPosition(pos) {
        var _a, _b;
        const position = typeof pos === "number" ? (_a = this.getPosition(pos)) === null || _a === void 0 ? void 0 : _a.position : pos;
        if (!position) {
            return null;
        }
        const departments = [];
        const costCenter = (_b = this.costCenters) === null || _b === void 0 ? void 0 : _b.find(({ entities }) => {
            var _a;
            for (const filter of entities) {
                if (filter.type === "venue") {
                    departments.push(...(((_a = this.venues.find((v) => v.id === filter.value)) === null || _a === void 0 ? void 0 : _a.departments) || []));
                }
                else if (filter.type === "department") {
                    const department = this.getDepartment(filter.value).department;
                    if (department) {
                        departments.push(department);
                    }
                }
            }
            return departments.some((dep) => dep.positions.some((pos) => pos.id === position.id));
        });
        return costCenter;
    }
    getCostCenter(context) {
        var _a, _b;
        const ctx = { ...context, company: this };
        return (_b = (_a = this.costCenters) === null || _a === void 0 ? void 0 : _a.sort((a, b) => (0, filters_1.getSpecificity)(b.entities) - (0, filters_1.getSpecificity)(a.entities))) === null || _b === void 0 ? void 0 : _b.find((c) => (0, filters_1.matchesFilters)(c.entities, ctx));
    }
    getWageTypeSet(context) {
        var _a, _b, _c, _d;
        const ctx = { ...context, company: this };
        const wageTypeSets = this.settings.accounting.salaryConfigs;
        wageTypeSets.forEach((set) => (set.entities =
            set.entities || set.employmentTypes.map((t) => ({ type: "employmentType", value: Number(t) }))));
        const contract = !context.date
            ? (_a = context.employee) === null || _a === void 0 ? void 0 : _a.latestContract
            : typeof context.date === "string"
                ? (0, utils_1.getContractForDate)(((_b = context.employee) === null || _b === void 0 ? void 0 : _b.contracts) || [], context.date)
                : (0, utils_1.getContractForRange)(((_c = context.employee) === null || _c === void 0 ? void 0 : _c.contracts) || [], context.date);
        const positionId = typeof context.position === "number" ? context.position : (_d = context.position) === null || _d === void 0 ? void 0 : _d.id;
        const salary = (0, contract_util_1.getSalaryOrDefault)(positionId, (contract === null || contract === void 0 ? void 0 : contract.salaries) || []);
        if (salary === null || salary === void 0 ? void 0 : salary.accountingSalaryConfigId) {
            const set = wageTypeSets.find((s) => s.id === salary.accountingSalaryConfigId);
            if (set) {
                return set;
            }
        }
        return wageTypeSets
            .sort((a, b) => (0, filters_1.getSpecificity)(b.entities) - (0, filters_1.getSpecificity)(a.entities))
            .find((s) => (0, filters_1.matchesFilters)(s.entities, ctx));
    }
};
exports.Company = Company;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Company.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Company.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "DE" }),
    __metadata("design:type", String)
], Company.prototype, "country", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Company.prototype, "address", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Company.prototype, "city", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Company.prototype, "postalCode", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Company.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Company.prototype, "phone", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Company.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Company.prototype, "updated", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Venue),
    (0, typeorm_1.OneToMany)(() => Venue, (v) => v.company, { eager: false }),
    __metadata("design:type", Array)
], Company.prototype, "venues", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Venue),
    __metadata("design:type", Array)
], Company.prototype, "archivedVenues", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Employee),
    (0, typeorm_1.OneToMany)(() => Employee, (v) => v.company, { eager: false }),
    __metadata("design:type", Array)
], Company.prototype, "employees", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Company.prototype, "settingsId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => CompanySettings),
    (0, typeorm_1.OneToOne)(() => CompanySettings, { eager: false, cascade: false }),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", CompanySettings)
], Company.prototype, "settings", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-array", { default: "employees,roster,time" }),
    __metadata("design:type", Array)
], Company.prototype, "features", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-array", { default: "" }),
    __metadata("design:type", Array)
], Company.prototype, "partnerIntegrations", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], Company.prototype, "isBetaCustomer", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Account),
    __metadata("design:type", Object)
], Company.prototype, "owner", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], Company.prototype, "billingId", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], Company.prototype, "billingCustomerId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => BillingInfo),
    (0, typeorm_1.OneToOne)(() => BillingInfo, { eager: false, cascade: true, nullable: true }),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", Object)
], Company.prototype, "billing", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Company.prototype, "comments", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Company.prototype, "secret", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: CompanyStatus.Active }),
    __metadata("design:type", String)
], Company.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => CompanyLifeCycleEvent, (event) => event.company, { eager: false }),
    (0, class_transformer_1.Type)(() => CompanyLifeCycleEvent),
    __metadata("design:type", Array)
], Company.prototype, "lifeCycleEvents", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => DocumentTag),
    (0, typeorm_1.OneToMany)(() => DocumentTag, (tag) => tag.company, { eager: true }),
    __metadata("design:type", Array)
], Company.prototype, "documentTags", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => entities_1.EmployeeTag),
    (0, typeorm_1.OneToMany)(() => entities_1.EmployeeTag, (tag) => tag.company, { eager: true }),
    __metadata("design:type", Array)
], Company.prototype, "employeeTags", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => BonusType),
    (0, typeorm_1.OneToMany)(() => BonusType, (t) => t.company, { eager: true }),
    __metadata("design:type", Array)
], Company.prototype, "bonusTypes", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => BenefitType),
    (0, typeorm_1.OneToMany)(() => BenefitType, (t) => t.company, { eager: true }),
    __metadata("design:type", Array)
], Company.prototype, "benefitTypes", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], Company.prototype, "costCenters", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], Company.prototype, "wageTypes", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], Company.prototype, "apiKey", void 0);
exports.Company = Company = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Company);
let Account = class Account {
    constructor(vals = {}) {
        this.firstName = "";
        this.lastName = "";
        this.pwdHash = null;
        this.admin = false;
        Object.assign(this, vals);
    }
    async onAfterLoad() {
        this.hasPassword = Boolean(this.pwdHash);
    }
    get name() {
        return `${this.firstName} ${this.lastName}`;
    }
};
exports.Account = Account;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Account.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({ unique: true, nullable: true }),
    __metadata("design:type", String)
], Account.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Account.prototype, "firstName", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Account.prototype, "lastName", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Account.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Account.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-json", { nullable: true }),
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Object)
], Account.prototype, "pwdHash", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => Employee, (e) => e.account, { eager: true }),
    (0, class_transformer_1.Type)(() => Employee),
    __metadata("design:type", Array)
], Account.prototype, "profiles", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], Account.prototype, "setPwdToken", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => entities_1.Session),
    (0, typeorm_1.OneToMany)(() => entities_1.Session, (s) => s.account),
    __metadata("design:type", Array)
], Account.prototype, "sessions", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], Account.prototype, "admin", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], Account.prototype, "featurebaseUserHash", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Company),
    __metadata("design:type", Company)
], Account.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.AfterLoad)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], Account.prototype, "onAfterLoad", null);
exports.Account = Account = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Account);
let Venue = class Venue {
    constructor(vals = {}) {
        this.name = "";
        this.address = "";
        this.city = "";
        this.postalCode = "";
        this.state = "BY";
        /** @deprecated */
        this.email = "";
        this.phone = "";
        this.order = 0;
        this.archivedDepartments = [];
        this.archived = false;
        this.accountingClient = null;
        this.accountingConsultant = null;
        this.cashbookLedger = null;
        this.realAccountsLength = null;
        this.mealValueLunch = null;
        this.mealValueDinner = null;
        Object.assign(this, vals);
    }
    get enabledHolidays() {
        return (this.holidays ||
            Object.values(holidays_1.HOLIDAYS)
                .flat()
                .filter((h) => h.states.includes(this.state))
                .filter((h) => !h.noRealHoliday)
                .map((h) => h.name));
    }
    get stateName() {
        const state = Object.values([localized_1.Localized.AT.states, localized_1.Localized.DE.states])
            .flat()
            .find((state) => state.code === this.state);
        return (state && state.name) || "";
    }
};
exports.Venue = Venue;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Venue.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: "int", nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "venueNumber", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Company, (c) => c.venues, { onDelete: "CASCADE" }),
    (0, class_transformer_1.Type)(() => Company),
    __metadata("design:type", Company)
], Venue.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Venue.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Venue.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Venue.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Venue.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Venue.prototype, "address", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Venue.prototype, "city", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Venue.prototype, "postalCode", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Venue.prototype, "state", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Venue.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Venue.prototype, "phone", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], Venue.prototype, "order", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => Department, (d) => d.venue, { eager: true }),
    (0, class_transformer_1.Type)(() => Department),
    __metadata("design:type", Array)
], Venue.prototype, "departments", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Department),
    __metadata("design:type", Array)
], Venue.prototype, "archivedDepartments", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], Venue.prototype, "archived", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => RosterTemplate, (t) => t.venue, { eager: true, cascade: true }),
    (0, class_transformer_1.Type)(() => RosterTemplate),
    __metadata("design:type", Array)
], Venue.prototype, "rosterTemplates", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => TimeSettings, { eager: false, cascade: false, nullable: true, onDelete: "SET NULL" }),
    (0, class_transformer_1.Type)(() => TimeSettings),
    __metadata("design:type", Object)
], Venue.prototype, "timeSettings", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "timeSettingsId", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "holidays", void 0);
__decorate([
    (0, typeorm_1.Column)("text", { nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "accountingClient", void 0);
__decorate([
    (0, typeorm_1.Column)("text", { nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "accountingConsultant", void 0);
__decorate([
    (0, typeorm_1.Column)("text", { nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "cashbookLedger", void 0);
__decorate([
    (0, typeorm_1.Column)("int", { nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "realAccountsLength", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true, default: null }),
    __metadata("design:type", Object)
], Venue.prototype, "mealValueBreakfast", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true, default: null }),
    __metadata("design:type", Object)
], Venue.prototype, "mealValueLunch", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true, default: null }),
    __metadata("design:type", Object)
], Venue.prototype, "mealValueDinner", void 0);
exports.Venue = Venue = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Unique)(["companyId", "venueNumber"]),
    __metadata("design:paramtypes", [Object])
], Venue);
let Department = class Department {
    constructor(vals = {}) {
        this.name = "";
        this.archivedPositions = [];
        this.order = 0;
        this.archived = false;
        this.rosterOrder = [];
        Object.assign(this, vals);
    }
};
exports.Department = Department;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Department.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Department.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Department.prototype, "venueId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Venue, (v) => v.departments, { onDelete: "CASCADE" }),
    (0, class_transformer_1.Type)(() => Venue),
    __metadata("design:type", Venue)
], Department.prototype, "venue", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => Position, (position) => position.department, { eager: true, cascade: true }),
    (0, class_transformer_1.Type)(() => Position),
    __metadata("design:type", Array)
], Department.prototype, "positions", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Position),
    __metadata("design:type", Array)
], Department.prototype, "archivedPositions", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Department.prototype, "color", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], Department.prototype, "order", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], Department.prototype, "archived", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-array", { default: "" }),
    __metadata("design:type", Array)
], Department.prototype, "rosterOrder", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => TimeSettings, { eager: false, cascade: false, nullable: true, onDelete: "SET NULL" }),
    (0, class_transformer_1.Type)(() => TimeSettings),
    __metadata("design:type", Object)
], Department.prototype, "timeSettings", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], Department.prototype, "timeSettingsId", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], Department.prototype, "bonusesAreTaxed", void 0);
exports.Department = Department = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Department);
let Position = class Position {
    constructor(vals) {
        this.active = true;
        this.order = 0;
        if (vals) {
            if (vals.id) {
                this.id = vals.id;
            }
            this.name = vals.name || "";
            this.color = vals.color || "";
            if (typeof vals.order === "number") {
                this.order = vals.order;
            }
            if (vals.departmentId) {
                this.departmentId = vals.departmentId;
            }
        }
    }
};
exports.Position = Position;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Position.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Position.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Position.prototype, "departmentId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Department, (dep) => dep.positions, { onDelete: "CASCADE" }),
    __metadata("design:type", Department)
], Position.prototype, "department", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], Position.prototype, "active", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => Employee, (emp) => emp.positions),
    __metadata("design:type", Array)
], Position.prototype, "employees", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => JobPosting, (posting) => posting.positions),
    __metadata("design:type", Array)
], Position.prototype, "jobPostings", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], Position.prototype, "order", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Position.prototype, "color", void 0);
exports.Position = Position = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Position);
var InviteStatus;
(function (InviteStatus) {
    InviteStatus["Created"] = "created";
    InviteStatus["Sent"] = "sent";
    InviteStatus["DeliveryFailed"] = "delivery_failed";
    InviteStatus["Rejected"] = "rejected";
    InviteStatus["Accepted"] = "accepted";
})(InviteStatus || (exports.InviteStatus = InviteStatus = {}));
var EmployeeStatus;
(function (EmployeeStatus) {
    EmployeeStatus["Probation"] = "probation";
    EmployeeStatus["Active"] = "active";
    EmployeeStatus["Retired"] = "retired";
})(EmployeeStatus || (exports.EmployeeStatus = EmployeeStatus = {}));
function employeeStatusLabel(status) {
    switch (status) {
        case EmployeeStatus.Probation:
            return "Auf Probe";
        case EmployeeStatus.Active:
            return "Aktiv";
        case EmployeeStatus.Retired:
            return "Ausgeschieden";
    }
}
function employeeStatusColor(status) {
    switch (status) {
        case EmployeeStatus.Probation:
            return "orange";
        case EmployeeStatus.Active:
            return "green";
        case EmployeeStatus.Retired:
            return "red";
    }
}
function employeeStatusIcon(status) {
    switch (status) {
        case EmployeeStatus.Probation:
            return "person-circle-question";
        case EmployeeStatus.Active:
            return "person-circle-check";
        case EmployeeStatus.Retired:
            return "person-circle-xmark";
    }
}
var Gender;
(function (Gender) {
    Gender["Male"] = "m";
    Gender["Female"] = "w";
    Gender["NonBinary"] = "d";
    Gender["Undetermined"] = "x";
})(Gender || (exports.Gender = Gender = {}));
function genderLabel(gender) {
    switch (gender) {
        case Gender.Male:
            return "männlich";
        case Gender.Female:
            return "weiblich";
        case Gender.NonBinary:
            return "divers";
        case Gender.Undetermined:
            return "unbestimmt";
    }
}
let Employee = class Employee {
    constructor(vals = {}) {
        this.role = Role.Worker;
        /** @deprecated starting v1.25.0 in favor of `access` object */
        this.permissions = [];
        this.access = null;
        this.firstName = "";
        this.lastName = "";
        this.title = "";
        this.callName = "";
        this.address = "";
        this.city = "";
        this.postalCode = "";
        this.email = "";
        this.phone = "";
        this.phone2 = "";
        this.birthCountry = "";
        this.nationality = "";
        this.taxId = "";
        this.socialSecurityNumber = "";
        this.notes = "";
        this.avatar = "";
        this.timePin = "";
        this.shiftTemplates = [];
        this.rosterTabs = [];
        this.notifications = exports.defaultNotificationSettings;
        this.status = EmployeeStatus.Active;
        this.scheduledStatusChange = null;
        Object.assign(this, vals);
    }
    get name() {
        return `${this.firstName}${this.callName ? ` "${this.callName}"` : ""}${this.lastName ? ` ${this.lastName}` : ""}`;
    }
    get currentContract() {
        var _a;
        const today = (0, utils_1.toDateString)(new Date());
        return (((_a = this.contracts) === null || _a === void 0 ? void 0 : _a.find((contract) => contract.start <= today && (!contract.end || contract.end > today))) ||
            null);
    }
    get firstContract() {
        var _a;
        return ((_a = this.contracts) === null || _a === void 0 ? void 0 : _a.sort((a, b) => (a.start < b.start ? -1 : 1))[0]) || null;
    }
    get latestContract() {
        var _a;
        return ((_a = this.contracts) === null || _a === void 0 ? void 0 : _a.sort((a, b) => (!a.end ? -1 : !b.end ? 1 : a.end > b.end ? -1 : 1))[0]) || null;
    }
    get employedInterval() {
        if (!this.contracts) {
            return null;
        }
        const today = (0, utils_1.toDateString)(new Date());
        const sortedContracts = this.contracts.slice().sort((a, b) => (a.start < b.start ? -1 : 1));
        let earliestStart = null;
        let latestEnd = null;
        for (const contract of sortedContracts) {
            // ignore invalid contracts
            if (!contract.start)
                continue;
            // if contracts are starting in the future, we can stop
            if (today < contract.start) {
                break;
            }
            const start = (0, utils_1.parseDateString)(contract.start);
            if (!earliestStart) {
                earliestStart = start;
            }
            // if there is a 365 days gap in contracts, we reset the earliest start
            if (latestEnd && start && start.getTime() - latestEnd.getTime() > 365 * time_1.day) {
                earliestStart = start;
            }
            // if contract has an end before today, we continue, otherwise we use today and stop
            if (contract.end && contract.end < today) {
                latestEnd = (0, utils_1.parseDateString)(contract.end);
            }
            else {
                latestEnd = (0, utils_1.parseDateString)(today);
                break;
            }
        }
        if (!earliestStart || !latestEnd) {
            return null;
        }
        return [earliestStart, latestEnd];
    }
    get active() {
        return this.status !== EmployeeStatus.Retired;
    }
    getAllContractsForRange(range) {
        return (0, utils_1.getAllContractsForRange)(this.contracts || [], range);
    }
    getContractForRange(range) {
        return (0, utils_1.getContractForRange)(this.contracts || [], range);
    }
    // TODO: This should not intake a string but a branded DateString type
    getContractForDate(date) {
        return this.contracts && (0, utils_1.getContractForDate)(this.contracts, date);
    }
    hasPermission(scope) {
        var _a, _b;
        return this.role <= Role.Owner || Boolean((_b = (_a = this.access) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.includes(scope));
    }
    isBirthDay(date) {
        if (!this.birthday) {
            return false;
        }
        const d = date instanceof Date ? date : (0, utils_1.parseDateString)(date);
        const bd = (0, utils_1.parseDateString)(this.birthday);
        return bd && d && bd.getMonth() === d.getMonth() && bd.getDate() === d.getDate();
    }
};
exports.Employee = Employee;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Employee.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "accountId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Account, { nullable: true, onDelete: "SET NULL" }),
    (0, class_transformer_1.Type)(() => Account),
    __metadata("design:type", Object)
], Employee.prototype, "account", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], Employee.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Company, (c) => c.employees, { onDelete: "CASCADE" }),
    __metadata("design:type", Company)
], Employee.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: Role.Worker }),
    __metadata("design:type", Number)
], Employee.prototype, "role", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-array", { default: "" }),
    __metadata("design:type", Array)
], Employee.prototype, "permissions", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "access", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Number)
], Employee.prototype, "staffNumber", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "firstName", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "lastName", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Employee.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Employee.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "title", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "callName", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "address", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "city", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "postalCode", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "phone", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "phone2", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: "date", nullable: true }),
    __metadata("design:type", String)
], Employee.prototype, "birthday", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "birthName", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "birthCity", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "birthCountry", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "nationality", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], Employee.prototype, "gender", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "taxId", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "socialSecurityNumber", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "notes", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "avatar", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "timePin", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Position),
    (0, typeorm_1.ManyToMany)(() => Position, (position) => position.employees, { eager: true }),
    (0, typeorm_1.JoinTable)(),
    __metadata("design:type", Array)
], Employee.prototype, "positions", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], Employee.prototype, "positionsOrder", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => Contract, (contract) => contract.employee, { eager: true }),
    (0, class_transformer_1.Type)(() => Contract),
    __metadata("design:type", Array)
], Employee.prototype, "contracts", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => TimeSettings, { eager: false, cascade: false, nullable: true, onDelete: "SET NULL" }),
    (0, class_transformer_1.Type)(() => TimeSettings),
    __metadata("design:type", Object)
], Employee.prototype, "timeSettings", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "timeSettingsId", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-json", { default: "[]" }),
    __metadata("design:type", Array)
], Employee.prototype, "shiftTemplates", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-json", { default: "[]" }),
    __metadata("design:type", Array)
], Employee.prototype, "rosterTabs", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { default: JSON.stringify(exports.defaultNotificationSettings) }),
    __metadata("design:type", Object)
], Employee.prototype, "notifications", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "invite", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-array", { default: Object.values(StaffAppFeature).join(",") }),
    __metadata("design:type", Array)
], Employee.prototype, "staffAppFeatures", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], Employee.prototype, "isContactPerson", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: EmployeeStatus.Active }),
    __metadata("design:type", String)
], Employee.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "scheduledStatusChange", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => entities_1.EmployeeTag, (tag) => tag.employees, { eager: true }),
    (0, typeorm_1.JoinTable)(),
    (0, class_transformer_1.Type)(() => entities_1.EmployeeTag),
    __metadata("design:type", Array)
], Employee.prototype, "tags", void 0);
exports.Employee = Employee = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Employee);
let Contract = class Contract {
    constructor(vals = {}) {
        this.end = null;
        this.nominalHoursMode = NominalHoursMode.WeekFactor;
        this.hoursPerWeek = 0;
        this.absenceHours = 0;
        this.annualTimeSheet = false;
        this.enableSFNLedger = false;
        this.sfnAdvance = 0;
        this.christmasBonus = 0;
        this.vacationBonus = 0;
        this.employmentType = EmploymentType.Regular;
        this.maxSalary = 0;
        this.vacationDays = 0;
        this.vacationIncrement = VacationIncrement.Monthly;
        this.bonusNight1 = 25;
        this.bonusNight2 = 40;
        this.bonusSunday = 50;
        this.bonusHoliday = 125;
        this.bonusSpecial = 0;
        this.stackBonuses = true;
        this.benefitsOld = [];
        this.ignoreIssues = [];
        this.comment = "";
        this.blocked = false;
        Object.defineProperty(this, "inclusiveEnd", {
            enumerable: true,
            get: () => this.end && (0, utils_1.dateAdd)(this.end, { days: -1 }),
            set: (end) => (this.end = (end && (0, utils_1.dateAdd)(end, { days: 1 })) || null),
        });
        Object.assign(this, vals);
    }
    get defaultSalary() {
        return (0, contract_util_1.getDefaultSalary)(this.salaries);
    }
    get fixedWorkDays() {
        return (0, contract_util_1.hasFixedWorkDays)(this.nominalHoursMode);
    }
    get nominalWeeklyHours() {
        return (0, contract_util_1.getNominalWeeklyHours)({
            nominalHoursMode: this.nominalHoursMode,
            hoursPerWeek: this.hoursPerWeek,
            hoursPerDay: this.hoursPerDay,
        });
    }
    isActiveOn(date) {
        return (0, contract_util_1.isActiveOn)(date, this);
    }
};
exports.Contract = Contract;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Contract.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Contract.prototype, "employeeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Employee, (emp) => emp.contracts, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], Contract.prototype, "employee", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Contract.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Contract.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], Contract.prototype, "start", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: "date", nullable: true }),
    __metadata("design:type", Object)
], Contract.prototype, "end", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: NominalHoursMode.WeekFactor }),
    __metadata("design:type", Number)
], Contract.prototype, "nominalHoursMode", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], Contract.prototype, "hoursPerWeek", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-json", { nullable: true }),
    __metadata("design:type", Object)
], Contract.prototype, "hoursPerDay", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: AbsenceMode.Average }),
    __metadata("design:type", Number)
], Contract.prototype, "absenceMode", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], Contract.prototype, "absenceHours", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], Contract.prototype, "annualTimeSheet", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], Contract.prototype, "enableSFNLedger", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], Contract.prototype, "sfnAdvance", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], Contract.prototype, "christmasBonus", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], Contract.prototype, "vacationBonus", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: EmploymentType.Regular }),
    __metadata("design:type", Number)
], Contract.prototype, "employmentType", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], Contract.prototype, "maxSalary", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], Contract.prototype, "vacationDays", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Contract.prototype, "vacationIncrement", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 25 }),
    __metadata("design:type", Number)
], Contract.prototype, "bonusNight1", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 40 }),
    __metadata("design:type", Number)
], Contract.prototype, "bonusNight2", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 50 }),
    __metadata("design:type", Number)
], Contract.prototype, "bonusSunday", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 125 }),
    __metadata("design:type", Number)
], Contract.prototype, "bonusHoliday", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], Contract.prototype, "bonusSpecial", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], Contract.prototype, "stackBonuses", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-json", { default: "[]", name: "benefits" }),
    __metadata("design:type", Array)
], Contract.prototype, "benefitsOld", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => Salary, (salary) => salary.contract, { eager: true }),
    (0, class_transformer_1.Type)(() => Salary),
    __metadata("design:type", Array)
], Contract.prototype, "salaries", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => Bonus, (bonus) => bonus.contract, { eager: true }),
    (0, class_transformer_1.Type)(() => Bonus),
    __metadata("design:type", Array)
], Contract.prototype, "bonuses", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => Benefit, (benefit) => benefit.contract, { eager: true }),
    (0, class_transformer_1.Type)(() => Benefit),
    __metadata("design:type", Array)
], Contract.prototype, "benefits", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-json", { default: "[]" }),
    __metadata("design:type", Array)
], Contract.prototype, "ignoreIssues", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Contract.prototype, "comment", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], Contract.prototype, "blocked", void 0);
exports.Contract = Contract = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Contract);
let Salary = class Salary {
    constructor(init = {}) {
        this.amount = 0;
        this.type = "hourly";
        this.commission = 0;
        Object.assign(this, init);
    }
};
exports.Salary = Salary;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Salary.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: false }),
    __metadata("design:type", Number)
], Salary.prototype, "contractId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Contract, (c) => c.salaries, { onDelete: "CASCADE" }),
    __metadata("design:type", Contract)
], Salary.prototype, "contract", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], Salary.prototype, "positionId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Position, { nullable: true, onDelete: "CASCADE" }),
    __metadata("design:type", Object)
], Salary.prototype, "position", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], Salary.prototype, "amount", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "hourly" }),
    __metadata("design:type", String)
], Salary.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], Salary.prototype, "commission", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], Salary.prototype, "accountingSalaryConfigId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => AccountingSalaryConfig, { nullable: true }),
    __metadata("design:type", Object)
], Salary.prototype, "accountingSalaryConfig", void 0);
exports.Salary = Salary = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Index)(["contractId", "positionId"], { unique: true }),
    __metadata("design:paramtypes", [Object])
], Salary);
var time_entry_type_2 = require("./time-entries/time-entry-type");
Object.defineProperty(exports, "TimeEntryType", { enumerable: true, get: function () { return time_entry_type_2.TimeEntryType; } });
Object.defineProperty(exports, "absenceTypes", { enumerable: true, get: function () { return time_entry_type_2.absenceTypes; } });
Object.defineProperty(exports, "timeEntryAbsenceTypes", { enumerable: true, get: function () { return time_entry_type_2.timeEntryAbsenceTypes; } });
Object.defineProperty(exports, "timeEntryTypeColor", { enumerable: true, get: function () { return time_entry_type_2.timeEntryTypeColor; } });
function companyStatusColor(status) {
    switch (status) {
        case CompanyStatus.Trialing:
            return colors_1.colors.grey;
        case CompanyStatus.Probation:
            return colors_1.colors.purple;
        case CompanyStatus.Active:
            return colors_1.colors.green;
        case CompanyStatus.Paused:
            return colors_1.colors.orange;
        case CompanyStatus.Canceled:
            return colors_1.colors.red;
        case CompanyStatus.PaymentOverdue:
            return colors_1.colors.red;
        default:
            return "";
    }
}
function companyStatusLabel(status) {
    switch (status) {
        case CompanyStatus.Trialing:
            return "Testphase";
        case CompanyStatus.Probation:
            return "Probezeit";
        case CompanyStatus.Active:
            return "Aktiv";
        case CompanyStatus.Paused:
            return "Pausiert";
        case CompanyStatus.Canceled:
            return "Gekündigt";
        case CompanyStatus.PaymentOverdue:
            return "Zahlungsverzug";
        default:
            return "";
    }
}
function availabilityColor(status) {
    switch (status) {
        case AvailabilityStatus.Available:
            return colors_1.colors.green;
        case AvailabilityStatus.Unavailable:
            return colors_1.colors.red;
        case AvailabilityStatus.Preferred:
            return colors_1.colors.purple;
        case AvailabilityStatus.Unpreferred:
            return colors_1.colors.orange;
        default:
            return "";
    }
}
function availabilityLabel(status) {
    switch (status) {
        case AvailabilityStatus.Available:
            return "Verfügbar";
        case AvailabilityStatus.Unavailable:
            return "Nicht Verfügbar";
        case AvailabilityStatus.Preferred:
            return "Bevorzugt";
        case AvailabilityStatus.Unpreferred:
            return "Wunschfrei";
        default:
            return "";
    }
}
function availabilityIcon(status) {
    switch (status) {
        case AvailabilityStatus.Available:
            return "thumbs-up";
        case AvailabilityStatus.Unavailable:
            return "ban";
        case AvailabilityStatus.Preferred:
            return "heart";
        case AvailabilityStatus.Unpreferred:
            return "couch";
        default:
            return "";
    }
}
function repeatsLabel(repeats) {
    switch (repeats) {
        case "never":
            return "niemals";
        case "weekly":
            return "wöchtentlich";
        case "monthly":
            return "monatlich";
        case "yearly":
            return "jährlich";
    }
}
const timeEntryPublishedDateProperties = ["time", "deleted", "startPlanned", "endPlanned"];
class DatePropertiesTransformer {
    constructor(properties) {
        this.properties = properties;
    }
    to(value) {
        if (!value) {
            // @ts-ignore-next-line dts file generation
            return value;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const obj = { ...value };
        for (const key of this.properties) {
            if (obj[key] instanceof Date) {
                obj[key] = obj[key].toISOString();
            }
        }
        return obj;
    }
    from(value) {
        if (!value || typeof value !== "object") {
            return value;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const info = { ...value };
        for (const key of this.properties) {
            if (typeof info[key] === "string") {
                info[key] = new Date(info[key]);
            }
        }
        return info;
    }
}
let TimeEntry = class TimeEntry {
    constructor(vals = {}) {
        this.created = new Date();
        this.updated = new Date();
        this.deleted = null;
        this.published = null;
        this.seen = null;
        this.taken = null;
        this.offered = null;
        this.startBreak = null;
        this.hours = null;
        this.days = null;
        this.resetBonus = null;
        this.comment = "";
        this.type = time_entry_type_1.TimeEntryType.Work;
        this.breakPlanned = null;
        this.breakAuto = null;
        this.breakLogged = null;
        this.break = null;
        this.mealsBreakfast = 0;
        this.mealsLunch = 0;
        this.mealsDinner = 0;
        this.paid = true;
        this.revenue = 0;
        this.result = null;
        this.resultPlanned = null;
        /** Total costs from maximized time result. Used for savings report. */
        this.resultMaxTotalCosts = null;
        this.wageType = null;
        Object.assign(this, vals);
    }
    get planned() {
        return this.startPlanned && this.endPlanned && [this.startPlanned, this.endPlanned];
    }
    get logged() {
        return this.startLogged && this.endLogged && [this.startLogged, this.endLogged];
    }
    get final() {
        return this.startFinal && this.endFinal && [this.startFinal, this.endFinal];
    }
    get start() {
        return this.startFinal || this.startPlanned || new Date(this.date);
    }
    get end() {
        return this.endFinal || this.endPlanned || new Date((0, utils_1.dateAdd)(this.date, { days: 1 }));
    }
    get durationPlanned() {
        return ((this.planned && (this.planned[1].getTime() - this.planned[0].getTime()) / 3600 / 1000) || 0);
    }
    get durationLogged() {
        return ((this.logged && (this.logged[1].getTime() - this.logged[0].getTime()) / 3600 / 1000) || 0);
    }
    get durationFinal() {
        return ((this.final && (this.final[1].getTime() - this.final[0].getTime()) / 3600 / 1000) || 0);
    }
    get duration() {
        const interval = this.final || this.planned;
        return ((interval && (interval[1].getTime() - interval[0].getTime()) / 3600 / 1000) || 0);
    }
    get status() {
        if (this.type !== time_entry_type_1.TimeEntryType.Work) {
            return "completed";
        }
        if (this.startFinal && this.endFinal) {
            return "completed";
        }
        else if (this.startBreak) {
            return "paused";
        }
        else if (this.startFinal) {
            return "ongoing";
        }
        else {
            return "scheduled";
        }
    }
    timeDisplay(mode) {
        var _a, _b;
        switch (mode) {
            case "planned": {
                const start = ((_a = this.startPlanned) === null || _a === void 0 ? void 0 : _a.toTimeString().slice(0, 5)) || "offen";
                const end = ((_b = this.endPlanned) === null || _b === void 0 ? void 0 : _b.toTimeString().slice(0, 5)) || "offen";
                return `${start} - ${end}`;
            }
            case "active":
                return `${this.startFinal.toTimeString().slice(0, 5)} - offen`;
            case "complete":
                return `${this.startFinal.toTimeString().slice(0, 5)} - ${this.endFinal.toTimeString().slice(0, 5)}`;
        }
    }
    get info() {
        var _a;
        return {
            date: this.date,
            employeeId: this.employeeId,
            positionId: ((_a = this.position) === null || _a === void 0 ? void 0 : _a.id) || null,
            startPlanned: this.startPlanned,
            endPlanned: this.endPlanned,
            deleted: this.deleted || null,
            comment: this.comment,
        };
    }
    matchesInfo({ date, employeeId, positionId, startPlanned, endPlanned, deleted, comment }) {
        var _a, _b;
        return (this.date === date &&
            this.employeeId === employeeId &&
            this.positionId === positionId &&
            ((_a = this.startPlanned) === null || _a === void 0 ? void 0 : _a.getTime()) === (startPlanned === null || startPlanned === void 0 ? void 0 : startPlanned.getTime()) &&
            ((_b = this.endPlanned) === null || _b === void 0 ? void 0 : _b.getTime()) === (endPlanned === null || endPlanned === void 0 ? void 0 : endPlanned.getTime()) &&
            Boolean(this.deleted) === Boolean(deleted) &&
            this.comment === comment);
    }
    getChangedProps(info = this.published) {
        var _a, _b, _c, _d;
        const changes = new Set();
        if (!info) {
            return changes;
        }
        for (const prop of ["date", "employeeId", "positionId", "comment"]) {
            if (this[prop] !== info[prop]) {
                changes.add(prop);
            }
        }
        if (((_a = this.startPlanned) === null || _a === void 0 ? void 0 : _a.getTime()) !== ((_b = info.startPlanned) === null || _b === void 0 ? void 0 : _b.getTime())) {
            changes.add("startPlanned");
        }
        if (((_c = this.endPlanned) === null || _c === void 0 ? void 0 : _c.getTime()) !== ((_d = info.endPlanned) === null || _d === void 0 ? void 0 : _d.getTime())) {
            changes.add("endPlanned");
        }
        if (Boolean(this.deleted) !== Boolean(info.deleted)) {
            changes.add("deleted");
        }
        return changes;
    }
    get isSeen() {
        return this.published && this.seen && this.matchesInfo(this.seen);
    }
    setSeen() {
        this.seen = {
            ...this.info,
            time: new Date(),
        };
    }
    get isPublished() {
        return this.published && this.matchesInfo(this.published);
    }
    setPublished() {
        this.published = {
            ...this.info,
            time: new Date(),
        };
        return this;
    }
    get isPast() {
        return this.date < (0, utils_1.toDateString)(new Date());
    }
    matchesTimeFilter({ from, to, fromRule, toRule }) {
        return (0, filters_1.matchesTimeFilter)(this, { from, to, fromRule, toRule });
    }
    overlapsWith(entry) {
        return entry.planned && this.planned && (0, time_1.overlap)(this.planned, [entry.planned]) > 0;
    }
};
exports.TimeEntry = TimeEntry;
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", String)
], TimeEntry.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], TimeEntry.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], TimeEntry.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: Date, nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "deleted", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: "jsonb",
        nullable: true,
        transformer: new DatePropertiesTransformer(timeEntryPublishedDateProperties),
    }),
    (0, encoding_1.TransformDateProperties)(timeEntryPublishedDateProperties),
    __metadata("design:type", Object)
], TimeEntry.prototype, "published", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: "jsonb",
        nullable: true,
        transformer: new DatePropertiesTransformer(timeEntryPublishedDateProperties),
    }),
    (0, encoding_1.TransformDateProperties)(timeEntryPublishedDateProperties),
    __metadata("design:type", Object)
], TimeEntry.prototype, "seen", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: Date, nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "taken", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: Date, nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "offered", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Position, { eager: true, nullable: true, onDelete: "SET NULL" }),
    (0, class_transformer_1.Type)(() => Position),
    __metadata("design:type", Object)
], TimeEntry.prototype, "position", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "positionId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Employee, { eager: false, nullable: true, onDelete: "CASCADE" }),
    (0, class_transformer_1.Type)(() => Employee),
    __metadata("design:type", Object)
], TimeEntry.prototype, "employee", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "employeeId", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], TimeEntry.prototype, "date", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "startPlannedOld", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "endPlannedOld", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "startLoggedOld", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "endLoggedOld", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "startFinalOld", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "endFinalOld", void 0);
__decorate([
    (0, typeorm_1.Column)("timestamptz", { nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "startPlanned", void 0);
__decorate([
    (0, typeorm_1.Column)("timestamptz", { nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "endPlanned", void 0);
__decorate([
    (0, typeorm_1.Column)("timestamptz", { nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "startLogged", void 0);
__decorate([
    (0, typeorm_1.Column)("timestamptz", { nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "endLogged", void 0);
__decorate([
    (0, typeorm_1.Column)("timestamptz", { nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "startFinal", void 0);
__decorate([
    (0, typeorm_1.Column)("timestamptz", { nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "endFinal", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: "timestamp", nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "startBreak", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: "float", nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "hours", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: "float", nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "days", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "resetBonus", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], TimeEntry.prototype, "comment", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], TimeEntry.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "breakPlanned", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "breakAuto", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "breakLogged", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "break", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], TimeEntry.prototype, "mealsBreakfast", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], TimeEntry.prototype, "mealsLunch", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], TimeEntry.prototype, "mealsDinner", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], TimeEntry.prototype, "paid", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-json", { default: "[]" }),
    __metadata("design:type", Array)
], TimeEntry.prototype, "ignoreIssues", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], TimeEntry.prototype, "revenue", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "result", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "resultPlanned", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "resultMaxTotalCosts", void 0);
__decorate([
    (0, typeorm_1.Column)("text", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "wageType", void 0);
exports.TimeEntry = TimeEntry = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Index)(["date"], { unique: false }),
    (0, typeorm_1.Index)("IDX_time_entry_position_id", ["positionId"], { unique: false }),
    (0, typeorm_1.Index)(["employeeId", "date"], { unique: false }),
    __metadata("design:paramtypes", [Object])
], TimeEntry);
let PublishedRoster = class PublishedRoster {
};
exports.PublishedRoster = PublishedRoster;
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", String)
], PublishedRoster.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], PublishedRoster.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], PublishedRoster.prototype, "from", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], PublishedRoster.prototype, "to", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Venue),
    (0, typeorm_1.ManyToOne)(() => Venue, { eager: true, onDelete: "CASCADE" }),
    __metadata("design:type", Venue)
], PublishedRoster.prototype, "venue", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], PublishedRoster.prototype, "venueId", void 0);
exports.PublishedRoster = PublishedRoster = __decorate([
    (0, typeorm_1.Entity)()
], PublishedRoster);
let RosterTemplate = class RosterTemplate {
};
exports.RosterTemplate = RosterTemplate;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], RosterTemplate.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RosterTemplate.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], RosterTemplate.prototype, "created", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Venue),
    (0, typeorm_1.ManyToOne)(() => Venue, (v) => v.rosterTemplates, { onDelete: "CASCADE" }),
    __metadata("design:type", Venue)
], RosterTemplate.prototype, "venue", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-json"),
    __metadata("design:type", Array)
], RosterTemplate.prototype, "shifts", void 0);
exports.RosterTemplate = RosterTemplate = __decorate([
    (0, typeorm_1.Entity)()
], RosterTemplate);
var TaxKey;
(function (TaxKey) {
    TaxKey[TaxKey["None"] = 0] = "None";
    TaxKey[TaxKey["Free"] = 1] = "Free";
    TaxKey[TaxKey["Sales7"] = 2] = "Sales7";
    TaxKey[TaxKey["Sales19"] = 3] = "Sales19";
    TaxKey[TaxKey["Input7"] = 8] = "Input7";
    TaxKey[TaxKey["Input19"] = 9] = "Input19";
    TaxKey[TaxKey["Input9_5"] = 408] = "Input9_5";
    // Sales5 = 11,
    // Sales16 = 12,
    // Input5 = 13,
    // Input16 = 14
})(TaxKey || (exports.TaxKey = TaxKey = {}));
function taxKeyLabel(key, date) {
    const specificDateOrToday = date || (0, utils_1.toDateString)(new Date());
    const inReducedTaxRange = specificDateOrToday >= "2020-07-01" && specificDateOrToday < "2021-01-01";
    switch (key) {
        case TaxKey.None:
            return "";
        case TaxKey.Free:
            return "Steuerfrei";
        case TaxKey.Sales7:
            return inReducedTaxRange ? "USt. 5%" : "USt. 7%";
        case TaxKey.Sales19:
            return inReducedTaxRange ? "USt. 16%" : "USt. 19%";
        case TaxKey.Input7:
            return inReducedTaxRange ? "VSt. 5%" : "VSt. 7%";
        case TaxKey.Input19:
            return inReducedTaxRange ? "VSt. 16%" : "VSt. 19%";
        case TaxKey.Input9_5:
            return date ? (date >= "2022-01-01" ? "VSt. 9,5%" : "VSt. 10,7%") : "VSt. 9,5/10,7%";
        default:
            return "";
    }
}
function taxKeyValue(key, date) {
    const reduced = date && date >= "2020-07-01" && date < "2021-01-01";
    switch (key) {
        case TaxKey.None:
        case TaxKey.Free:
            return 0;
        case TaxKey.Sales7:
        case TaxKey.Input7:
            return reduced ? 5 : 7;
        case TaxKey.Sales19:
        case TaxKey.Input19:
            return reduced ? 16 : 19;
        case TaxKey.Input9_5:
            return date && date >= "2022-01-01" ? 9.5 : 10.7;
        default:
            return 0;
    }
}
function revenueTypeLabel(type) {
    switch (type) {
        case RevenueType.Sales:
            return "Einnahme";
        case RevenueType.Expense:
            return "Ausgabe";
        case RevenueType.PayAdvance:
            return "Gehaltsvorschuss";
        case RevenueType.BankDeposit:
            return "Bankeinzahlung";
        case RevenueType.Deposit:
            return "Einzahlung";
        case RevenueType.CashCount:
            return "Kassenzählung";
        case RevenueType.Debt:
            return "Rechnung";
        case RevenueType.Adjustment:
            return "Ausgleichsbuchung";
        case RevenueType.Cashless:
            return "Bargeldlose Zahlung";
        case RevenueType.Other:
            return "Sonstiges";
        default:
            break;
    }
}
function revenueTypeIcon(type) {
    switch (type) {
        case RevenueType.Sales:
            return "money-bill-wave";
        case RevenueType.Expense:
            return "shopping-cart";
        case RevenueType.PayAdvance:
            return "hand-holding-usd";
        case RevenueType.BankDeposit:
            return "piggy-bank";
        case RevenueType.CashCount:
            return "coins";
        case RevenueType.Debt:
            return "file-invoice";
        case RevenueType.Adjustment:
            return "balance-scale";
        case RevenueType.Cashless:
            return "credit-card";
        case RevenueType.Other:
            return "euro-sign";
        default:
            return "list";
    }
}
var RevenueType;
(function (RevenueType) {
    RevenueType["Sales"] = "sales";
    RevenueType["Expense"] = "expense";
    RevenueType["Cashless"] = "cashless";
    RevenueType["Debt"] = "debt";
    RevenueType["Deposit"] = "deposit";
    RevenueType["PayAdvance"] = "advance";
    RevenueType["CashCount"] = "cash_count";
    RevenueType["Adjustment"] = "adjustment";
    RevenueType["BankDeposit"] = "bank_deposit";
    RevenueType["Other"] = "other";
})(RevenueType || (exports.RevenueType = RevenueType = {}));
let RevenueGroup = class RevenueGroup {
    constructor(vals) {
        this.type = RevenueType.Other;
        this.name = "";
        this.taxKey = TaxKey.None;
        this.ledger = "";
        this.costCenter = "";
        this.cashbook = true;
        this.reporting = true;
        this.daily = true;
        this.attributions = [];
        this.order = null;
        this.postingKey = "";
        this.count = 0;
        this.amount = 0;
        if (vals) {
            Object.assign(this, vals);
        }
    }
    createEntry() {
        return new RevenueEntry({
            group: this,
            groupId: this.id,
            venueId: this.venueId,
            type: this.type,
            name: this.name,
            taxKey: this.taxKey,
            postingKey: this.postingKey,
            ledger: this.ledger,
            costCenter: this.costCenter,
            reporting: this.reporting,
            cashbook: this.cashbook,
        });
    }
};
exports.RevenueGroup = RevenueGroup;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], RevenueGroup.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], RevenueGroup.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], RevenueGroup.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], RevenueGroup.prototype, "venueId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Venue, { eager: false, onDelete: "CASCADE" }),
    __metadata("design:type", Venue)
], RevenueGroup.prototype, "venue", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RevenueGroup.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RevenueGroup.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], RevenueGroup.prototype, "taxKey", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RevenueGroup.prototype, "ledger", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RevenueGroup.prototype, "costCenter", void 0);
__decorate([
    (0, typeorm_1.Column)("boolean", { default: true }),
    __metadata("design:type", Boolean)
], RevenueGroup.prototype, "cashbook", void 0);
__decorate([
    (0, typeorm_1.Column)("boolean", { default: true }),
    __metadata("design:type", Boolean)
], RevenueGroup.prototype, "reporting", void 0);
__decorate([
    (0, typeorm_1.Column)("boolean", { default: true }),
    __metadata("design:type", Boolean)
], RevenueGroup.prototype, "daily", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-json", { default: "[]" }),
    __metadata("design:type", Array)
], RevenueGroup.prototype, "attributions", void 0);
__decorate([
    (0, typeorm_1.Column)("int", { nullable: true }),
    __metadata("design:type", Object)
], RevenueGroup.prototype, "order", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], RevenueGroup.prototype, "postingKey", void 0);
exports.RevenueGroup = RevenueGroup = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], RevenueGroup);
let RevenueEntry = RevenueEntry_1 = class RevenueEntry {
    constructor(vals) {
        this.name = "";
        this.type = RevenueType.Other;
        this.amount = 0;
        this.tip = 0;
        this.cashBalance = 0;
        this.taxKey = TaxKey.None;
        this.postingKey = "";
        this.ledger = "";
        this.costCenter = "";
        this.receipt = "";
        this.invoice = "";
        this.daily = false;
        this.draft = false;
        this.readonly = false;
        this.countingLog = null;
        this.paid = null;
        this.cashbook = true;
        this.reporting = true;
        if (vals) {
            Object.assign(this, vals);
        }
    }
    get text() {
        return this.name;
    }
    get cash() {
        switch (this.type) {
            case RevenueType.CashCount:
                return 0;
            case RevenueType.Debt:
                return (0, openapi_1.add)(this.amount, this.tip);
            // case RevenueType.Expense:
            // case RevenueType.Cashless:
            // case RevenueType.Debt:
            // case RevenueType.SalaryAdvance:
            //     return -this.amount;
            default:
                return this.amount;
        }
    }
    get revenue() {
        switch (this.type) {
            case RevenueType.Sales:
            case RevenueType.Expense:
                return this.amount;
            default:
                return 0;
        }
    }
    get attributions() {
        return (this.group && this.group.attributions) || [];
    }
    clone() {
        return new RevenueEntry_1({
            type: this.type,
            venueId: this.venueId,
            name: this.name,
            taxKey: this.taxKey,
            ledger: this.ledger,
            costCenter: this.costCenter,
            groupId: this.groupId,
        });
    }
};
exports.RevenueEntry = RevenueEntry;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RevenueEntry.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RevenueEntry.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)("int", { nullable: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "sequence", void 0);
__decorate([
    (0, typeorm_1.Column)("int", { nullable: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "subSequence", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], RevenueEntry.prototype, "date", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], RevenueEntry.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], RevenueEntry.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "amount", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "tip", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "cashBalance", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "taxKey", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], RevenueEntry.prototype, "postingKey", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RevenueEntry.prototype, "ledger", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RevenueEntry.prototype, "costCenter", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RevenueEntry.prototype, "receipt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RevenueEntry.prototype, "invoice", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "venueId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Venue, { onDelete: "CASCADE" }),
    __metadata("design:type", Venue)
], RevenueEntry.prototype, "venue", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], RevenueEntry.prototype, "daily", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], RevenueEntry.prototype, "draft", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], RevenueEntry.prototype, "readonly", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "employeeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Employee, { nullable: true, onDelete: "SET NULL" }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "employee", void 0);
__decorate([
    (0, typeorm_1.Column)("simple-json", { nullable: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "countingLog", void 0);
__decorate([
    (0, typeorm_1.Column)("boolean", { nullable: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "paid", void 0);
__decorate([
    (0, typeorm_1.Column)("boolean", { default: true }),
    __metadata("design:type", Boolean)
], RevenueEntry.prototype, "cashbook", void 0);
__decorate([
    (0, typeorm_1.Column)("boolean", { default: true }),
    __metadata("design:type", Boolean)
], RevenueEntry.prototype, "reporting", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "groupId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => RevenueGroup, { nullable: true, eager: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "group", void 0);
exports.RevenueEntry = RevenueEntry = RevenueEntry_1 = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Index)(["venueId", "date"], { unique: false }),
    __metadata("design:paramtypes", [Object])
], RevenueEntry);
let RevenuePrediction = class RevenuePrediction {
    constructor(vals) {
        this.amount = 0;
        if (vals) {
            Object.assign(this, vals);
        }
    }
    get attributions() {
        return (this.group && this.group.attributions) || [];
    }
};
exports.RevenuePrediction = RevenuePrediction;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], RevenuePrediction.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], RevenuePrediction.prototype, "date", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], RevenuePrediction.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], RevenuePrediction.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], RevenuePrediction.prototype, "amount", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], RevenuePrediction.prototype, "groupId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => RevenueGroup, { onDelete: "CASCADE", eager: true }),
    __metadata("design:type", RevenueGroup)
], RevenuePrediction.prototype, "group", void 0);
exports.RevenuePrediction = RevenuePrediction = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], RevenuePrediction);
let RosterTargets = class RosterTargets {
    constructor() {
        this.revenue = null;
        this.productivity = null;
        this.hours = null;
        this.default = false;
    }
    get weekDay() {
        return (0, utils_1.parseDateString)(this.date).getDay();
    }
};
exports.RosterTargets = RosterTargets;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], RosterTargets.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], RosterTargets.prototype, "departmentId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Department, { eager: false, onDelete: "CASCADE" }),
    __metadata("design:type", Department)
], RosterTargets.prototype, "department", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: "date" }),
    __metadata("design:type", String)
], RosterTargets.prototype, "date", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], RosterTargets.prototype, "revenue", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], RosterTargets.prototype, "productivity", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], RosterTargets.prototype, "hours", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], RosterTargets.prototype, "default", void 0);
exports.RosterTargets = RosterTargets = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Index)(["departmentId", "date"], { unique: true })
], RosterTargets);
var AbsenceStatus;
(function (AbsenceStatus) {
    AbsenceStatus["Requested"] = "requested";
    AbsenceStatus["Approved"] = "approved";
    AbsenceStatus["Denied"] = "denied";
    AbsenceStatus["Inferred"] = "inferred";
})(AbsenceStatus || (exports.AbsenceStatus = AbsenceStatus = {}));
let Absence = class Absence {
    constructor(vals = {}) {
        this.notes = "";
        this.request = null;
        this.response = null;
        Object.assign(this, vals);
    }
};
exports.Absence = Absence;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Absence.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Absence.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Absence.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Absence.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], Absence.prototype, "employeeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Employee, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], Absence.prototype, "employee", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], Absence.prototype, "start", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], Absence.prototype, "end", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Absence.prototype, "notes", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Absence.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Absence.prototype, "request", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Absence.prototype, "response", void 0);
exports.Absence = Absence = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Absence);
var VacationPolicy;
(function (VacationPolicy) {
    VacationPolicy["AllowAll"] = "allow_all";
    VacationPolicy["DisallowRequests"] = "disallow_requests";
    VacationPolicy["DisallowAll"] = "disallow_all";
})(VacationPolicy || (exports.VacationPolicy = VacationPolicy = {}));
let RosterNote = class RosterNote {
    constructor(vals = {}) {
        this.color = null;
        this.filters = [];
        this.displayAsRosterNote = true;
        this.vacationPolicy = VacationPolicy.AllowAll;
        Object.assign(this, vals);
    }
};
exports.RosterNote = RosterNote;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], RosterNote.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], RosterNote.prototype, "text", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], RosterNote.prototype, "start", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], RosterNote.prototype, "end", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Company, { onDelete: "CASCADE" }),
    __metadata("design:type", Company)
], RosterNote.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], RosterNote.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: "text", nullable: true }),
    __metadata("design:type", Object)
], RosterNote.prototype, "color", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], RosterNote.prototype, "filters", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], RosterNote.prototype, "displayAsRosterNote", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: VacationPolicy.AllowAll }),
    __metadata("design:type", String)
], RosterNote.prototype, "vacationPolicy", void 0);
exports.RosterNote = RosterNote = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], RosterNote);
class GetEmployeeStatementsParams {
    constructor(vals = {}) {
        Object.assign(this, vals);
    }
}
exports.GetEmployeeStatementsParams = GetEmployeeStatementsParams;
__decorate([
    (0, class_transformer_1.Type)(() => Company),
    __metadata("design:type", Company)
], GetEmployeeStatementsParams.prototype, "company", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Employee),
    __metadata("design:type", Employee)
], GetEmployeeStatementsParams.prototype, "employee", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => TimeEntry),
    __metadata("design:type", Array)
], GetEmployeeStatementsParams.prototype, "entries", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => TimeEntry),
    __metadata("design:type", Array)
], GetEmployeeStatementsParams.prototype, "vacationEntries", void 0);
let CompanyLifeCycleEvent = class CompanyLifeCycleEvent {
    constructor(init = {}) {
        Object.assign(this, init);
    }
};
exports.CompanyLifeCycleEvent = CompanyLifeCycleEvent;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], CompanyLifeCycleEvent.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Company, (company) => company.lifeCycleEvents, {
        eager: false,
        nullable: false,
        onDelete: "CASCADE",
    }),
    __metadata("design:type", Company)
], CompanyLifeCycleEvent.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: false }),
    __metadata("design:type", Number)
], CompanyLifeCycleEvent.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], CompanyLifeCycleEvent.prototype, "comment", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], CompanyLifeCycleEvent.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], CompanyLifeCycleEvent.prototype, "createdBy", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], CompanyLifeCycleEvent.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], CompanyLifeCycleEvent.prototype, "date", void 0);
exports.CompanyLifeCycleEvent = CompanyLifeCycleEvent = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], CompanyLifeCycleEvent);
var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["Available"] = "available";
    AvailabilityStatus["Unavailable"] = "unavailable";
    AvailabilityStatus["Preferred"] = "preferred";
    AvailabilityStatus["Unpreferred"] = "unpreferred";
})(AvailabilityStatus || (exports.AvailabilityStatus = AvailabilityStatus = {}));
var Repeat;
(function (Repeat) {
    Repeat["Never"] = "never";
    Repeat["Weekly"] = "weekly";
    Repeat["Monthly"] = "monthly";
    Repeat["Yearly"] = "yearly";
})(Repeat || (exports.Repeat = Repeat = {}));
let Availability = class Availability {
    constructor(init = {}) {
        this.start = null;
        this.end = null;
        this.status = AvailabilityStatus.Available;
        this.comment = "";
        this.repeats = Repeat.Never;
        Object.assign(this, init);
    }
    get icon() {
        return availabilityIcon(this.status);
    }
    get timeLabel() {
        return this.start && this.end
            ? `${this.start.slice(0, 5)} - ${this.end.slice(0, 5)}`
            : this.start
                ? `ab ${this.start.slice(0, 5)}`
                : this.end
                    ? `bis ${this.end.slice(0, 5)}`
                    : "";
    }
    get label() {
        return this.timeLabel || availabilityLabel(this.status);
    }
    get fullLabel() {
        return `${availabilityLabel(this.status)} ${this.timeLabel}`;
    }
    get color() {
        return availabilityColor(this.status);
    }
    get repeatsLabel() {
        return repeatsLabel(this.repeats);
    }
};
exports.Availability = Availability;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Availability.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({ type: "timestamptz" }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Availability.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({ type: "timestamptz" }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Availability.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Availability.prototype, "employeeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Employee, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], Availability.prototype, "employee", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], Availability.prototype, "date", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true }),
    __metadata("design:type", Object)
], Availability.prototype, "start", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true }),
    __metadata("design:type", Object)
], Availability.prototype, "end", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: AvailabilityStatus.Available }),
    __metadata("design:type", String)
], Availability.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], Availability.prototype, "comment", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: Repeat.Never }),
    __metadata("design:type", String)
], Availability.prototype, "repeats", void 0);
exports.Availability = Availability = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Availability);
var FormStatus;
(function (FormStatus) {
    FormStatus["Draft"] = "draft";
    FormStatus["InProgress"] = "in_progress";
    FormStatus["Completed"] = "completed";
    FormStatus["Finalized"] = "finalized";
})(FormStatus || (exports.FormStatus = FormStatus = {}));
function formStatusColor(status) {
    switch (status) {
        case FormStatus.Draft:
            return colors_1.colors.grey;
        case FormStatus.InProgress:
            return colors_1.colors.teal;
        case FormStatus.Completed:
            return colors_1.colors.purple;
        case FormStatus.Finalized:
            return colors_1.colors.green;
    }
}
function formStatusLabel(status) {
    switch (status) {
        case FormStatus.Draft:
            return "Entwurf";
        case FormStatus.InProgress:
            return "In Bearbeitung";
        case FormStatus.Completed:
            return "Ausgefüllt";
        case FormStatus.Finalized:
            return "Fertiggestellt";
    }
}
let Form = class Form {
    constructor(init = {}) {
        this.description = "";
        this.status = FormStatus.Draft;
        this.requiresEmployeeSignature = false;
        this.requiresManagerSignature = false;
        this.considerCaretakerSignatureIfUnderage = false;
        this.autoFinalize = false;
        Object.assign(this, init);
    }
    get fields() {
        var _a;
        return ((_a = this.sections) === null || _a === void 0 ? void 0 : _a.flatMap((section) => section.fields)) || [];
    }
    checkCondition(condition) {
        if (!condition) {
            return true;
        }
        const field = this.fields.find((field) => field.name === condition.field);
        return (field === null || field === void 0 ? void 0 : field.value) === condition.value;
    }
    prefillForEmployee(employee) {
        for (const field of this.fields) {
            if (field.mapsTo) {
                const existing = employee[field.mapsTo];
                if (!existing) {
                    continue;
                }
                if (field.options && field.type === "string") {
                    const value = String(employee[field.mapsTo]);
                    const mapped = field.options.find((o) => o.value === value);
                    if (mapped) {
                        field.value = value;
                    }
                    continue;
                }
                switch (field.type) {
                    case "string":
                        field.value = String(employee[field.mapsTo]);
                        break;
                    case "date": {
                        const value = String(employee[field.mapsTo]);
                        if ((0, utils_1.parseDateString)(value)) {
                            field.value = value;
                        }
                        break;
                    }
                    case "number":
                        field.value = Number(employee[field.mapsTo]);
                        break;
                    case "boolean":
                        field.value = Boolean(employee[field.mapsTo]);
                        break;
                }
            }
        }
    }
    getHumanReadableValue(field) {
        var _a, _b;
        switch (field.type) {
            case "date":
                return (0, utils_1.formatDate)(field.value);
            case "boolean":
                return field.value ? "Ja" : "Nein";
            default:
                return ((_b = (_a = field.options) === null || _a === void 0 ? void 0 : _a.find((o) => o.value === field.value)) === null || _b === void 0 ? void 0 : _b.label) || field.value;
        }
    }
    get requiresCaretakerSignature() {
        var _a;
        if (!this.considerCaretakerSignatureIfUnderage) {
            return false;
        }
        const birthdayStr = (_a = this.fields.find((field) => field.name === "birthday")) === null || _a === void 0 ? void 0 : _a.value;
        //FIXME: somewhere null is assigned as default value
        if (!birthdayStr || typeof birthdayStr !== "string" || birthdayStr === "null") {
            return false;
        }
        return !(0, utils_1.isAdult)(new Date(birthdayStr), new Date());
    }
};
exports.Form = Form;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Form.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Form.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Form.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Company),
    __metadata("design:type", Company)
], Form.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Form.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Array)
], Form.prototype, "sections", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Form.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], Form.prototype, "requiresEmployeeSignature", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], Form.prototype, "requiresManagerSignature", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], Form.prototype, "considerCaretakerSignatureIfUnderage", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], Form.prototype, "autoFinalize", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Form.prototype, "managerSignature", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Form.prototype, "caretakerSignature", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Form.prototype, "employeeSignature", void 0);
exports.Form = Form = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Form);
var MimeType;
(function (MimeType) {
    MimeType["NONE"] = "";
    MimeType["PDF"] = "application/pdf";
    MimeType["PNG"] = "image/png";
    MimeType["JPG"] = "image/jpeg";
    MimeType["WEBP"] = "image/webp";
    MimeType["CSV"] = "text/csv";
    MimeType["TXT"] = "text/plain";
    MimeType["HTML"] = "text/html";
    MimeType["XML"] = "text/xml";
    MimeType["MSWordLegacy"] = "application/msword";
    MimeType["MSExcelLegacy"] = "application/vnd.ms-excel";
    MimeType["MSWord"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    MimeType["MSExcel"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    MimeType["Zip"] = "application/zip";
})(MimeType || (exports.MimeType = MimeType = {}));
function fileIcon(type) {
    switch (type) {
        case MimeType.PDF:
            return "file-pdf";
        case MimeType.TXT:
            return "file-text";
        case MimeType.CSV:
            return "file-csv";
        case MimeType.MSExcel:
        case MimeType.MSExcelLegacy:
            return "file-spreadsheet";
        case MimeType.MSWord:
        case MimeType.MSWordLegacy:
            return "file-word";
        case MimeType.PNG:
        case MimeType.JPG:
            return "file-image";
        case MimeType.Zip:
            return "file-zipper";
        default:
            return "file";
    }
}
function fileExtension(type) {
    switch (type) {
        case MimeType.PDF:
            return "pdf";
        case MimeType.TXT:
            return "txt";
        case MimeType.CSV:
            return "csv";
        case MimeType.MSExcel:
            return "xlsx";
        case MimeType.MSExcelLegacy:
            return "xls";
        case MimeType.MSWord:
            return "docx";
        case MimeType.MSWordLegacy:
            return "doc";
        case MimeType.PNG:
            return "png";
        case MimeType.JPG:
            return "jpg";
        case MimeType.Zip:
            return "zip";
        case MimeType.HTML:
            return "html";
        default:
            return "file";
    }
}
let Document = class Document {
    constructor(init = {}) {
        this.form = null;
        Object.assign(this, init);
    }
    get hideFromEmployee() {
        return this.tags.some((tag) => tag.hideFromEmployees);
    }
};
exports.Document = Document;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Document.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Document.prototype, "uuid", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], Document.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Company, { onDelete: "CASCADE" }),
    __metadata("design:type", Company)
], Document.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Document.prototype, "employeeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Employee, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], Document.prototype, "employee", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Document.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Document.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Number)
], Document.prototype, "createdById", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Employee, { onDelete: "SET NULL", nullable: true }),
    __metadata("design:type", Employee)
], Document.prototype, "createdBy", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Document.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Document.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Document.prototype, "comment", void 0);
__decorate([
    (0, typeorm_1.Column)("date"),
    __metadata("design:type", String)
], Document.prototype, "date", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => DocumentTag, (tag) => tag.documents, { eager: true }),
    (0, typeorm_1.JoinTable)(),
    (0, class_transformer_1.Type)(() => DocumentTag),
    __metadata("design:type", Array)
], Document.prototype, "tags", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], Document.prototype, "url", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Form),
    (0, typeorm_1.OneToOne)(() => Form, { nullable: true, eager: true, onDelete: "SET NULL" }),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", Object)
], Document.prototype, "form", void 0);
exports.Document = Document = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Document);
let DocumentTag = class DocumentTag {
    constructor(init = {}) {
        this.order = 0;
        this.hideFromEmployees = false;
        Object.assign(this, init);
    }
};
exports.DocumentTag = DocumentTag;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], DocumentTag.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], DocumentTag.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], DocumentTag.prototype, "color", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Company, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", Company)
], DocumentTag.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], DocumentTag.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => Document, (tag) => tag.tags, { eager: false }),
    __metadata("design:type", Array)
], DocumentTag.prototype, "documents", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], DocumentTag.prototype, "order", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], DocumentTag.prototype, "hideFromEmployees", void 0);
exports.DocumentTag = DocumentTag = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], DocumentTag);
let JobPosting = class JobPosting {
    constructor(init = {}) {
        this.title = "";
        this.description = "";
        this.payType = "hourly";
        this.start = null;
        this.end = null;
        this.employmentType = EmploymentType.Regular;
        this.images = [];
        Object.assign(this, init);
    }
};
exports.JobPosting = JobPosting;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], JobPosting.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)({ unique: true }),
    __metadata("design:type", String)
], JobPosting.prototype, "uuid", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], JobPosting.prototype, "title", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], JobPosting.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Company, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", Company)
], JobPosting.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], JobPosting.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Venue, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", Venue)
], JobPosting.prototype, "venue", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], JobPosting.prototype, "venueId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Position),
    (0, typeorm_1.ManyToMany)(() => Position, (position) => position.jobPostings, { eager: true }),
    (0, typeorm_1.JoinTable)(),
    __metadata("design:type", Array)
], JobPosting.prototype, "positions", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], JobPosting.prototype, "payType", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Number)
], JobPosting.prototype, "payAmount", void 0);
__decorate([
    (0, typeorm_1.Column)("date", { nullable: true }),
    __metadata("design:type", Object)
], JobPosting.prototype, "start", void 0);
__decorate([
    (0, typeorm_1.Column)("date", { nullable: true }),
    __metadata("design:type", Object)
], JobPosting.prototype, "end", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], JobPosting.prototype, "employmentType", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], JobPosting.prototype, "hoursPerWeek", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => JobApplication),
    (0, typeorm_1.OneToMany)(() => JobApplication, (v) => v.posting, { eager: true }),
    __metadata("design:type", Array)
], JobPosting.prototype, "applications", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Array)
], JobPosting.prototype, "images", void 0);
exports.JobPosting = JobPosting = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], JobPosting);
let JobApplication = class JobApplication {
    constructor(init = {}) {
        this.firstName = "";
        this.lastName = "";
        this.address = "";
        this.city = "";
        this.postalCode = "";
        this.email = "";
        this.phone = "";
        this.notes = "";
        this.headShot = "";
        this.message = "";
        Object.assign(this, init);
    }
};
exports.JobApplication = JobApplication;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], JobApplication.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => JobPosting, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", JobPosting)
], JobApplication.prototype, "posting", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], JobApplication.prototype, "postingId", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "firstName", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "lastName", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "address", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "city", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "postalCode", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "phone", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: "date", nullable: true }),
    __metadata("design:type", Object)
], JobApplication.prototype, "birthday", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "notes", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "headShot", void 0);
__decorate([
    (0, typeorm_1.Column)("date", { nullable: true }),
    __metadata("design:type", Object)
], JobApplication.prototype, "availableFrom", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], JobApplication.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "message", void 0);
exports.JobApplication = JobApplication = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], JobApplication);
var BonusTypeMode;
(function (BonusTypeMode) {
    BonusTypeMode["Daily"] = "daily";
    BonusTypeMode["WeekDays"] = "weekdays";
    BonusTypeMode["Date"] = "date";
    BonusTypeMode["Holidays"] = "holidays";
})(BonusTypeMode || (exports.BonusTypeMode = BonusTypeMode = {}));
let BonusTypeOverride = class BonusTypeOverride {
    constructor(init = {}) {
        Object.assign(this, init);
    }
};
exports.BonusTypeOverride = BonusTypeOverride;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], BonusTypeOverride.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], BonusTypeOverride.prototype, "subjectId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)("BonusType", { onDelete: "CASCADE", eager: false })
    // to avoid cyclical dependencies
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    __metadata("design:type", Object)
], BonusTypeOverride.prototype, "subject", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], BonusTypeOverride.prototype, "objectId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)("BonusType", { onDelete: "CASCADE", eager: false })
    // to avoid cyclical dependencies
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    __metadata("design:type", Object)
], BonusTypeOverride.prototype, "object", void 0);
exports.BonusTypeOverride = BonusTypeOverride = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Index)(["subjectId", "objectId"], { unique: true }),
    __metadata("design:paramtypes", [Object])
], BonusTypeOverride);
var BonusLegalType;
(function (BonusLegalType) {
    BonusLegalType["Night1"] = "night1";
    BonusLegalType["Night2"] = "night2";
    BonusLegalType["Sunday"] = "sunday";
    BonusLegalType["Holiday"] = "holiday";
    BonusLegalType["Special"] = "special";
})(BonusLegalType || (exports.BonusLegalType = BonusLegalType = {}));
var BonusCompType;
(function (BonusCompType) {
    BonusCompType["ModifiedHourlyRate"] = "modified_hourly_rate";
    BonusCompType["FixedHourlyRate"] = "fixed_hourly_rate";
    BonusCompType["FixedAmount"] = "fixed_amount";
})(BonusCompType || (exports.BonusCompType = BonusCompType = {}));
let BonusType = class BonusType {
    constructor(init = {}) {
        this.mode = BonusTypeMode.Daily;
        this.name = "";
        this.date = null;
        this.weekDays = null;
        this.holidays = null;
        this.intervals = [["00:00", "24:00"]];
        this.minDuration = null;
        this.minDurationPercent = null;
        this.shiftMustStartBefore = null;
        this.taxFree = true;
        this.continuedPay = false;
        this.compType = BonusCompType.ModifiedHourlyRate;
        this.archived = false;
        this.order = 0;
        Object.assign(this, init);
    }
    matchesDate(date, country) {
        var _a;
        switch (this.mode) {
            case BonusTypeMode.Daily:
                return true;
            case BonusTypeMode.Date:
                return date.endsWith(this.date);
            case BonusTypeMode.Holidays:
                return Boolean((0, holidays_1.getHolidayForDate)(date, { holidays: this.holidays || undefined, country }));
            case BonusTypeMode.WeekDays:
                return (_a = this.weekDays) === null || _a === void 0 ? void 0 : _a.includes(new Date(date).getDay());
        }
    }
};
exports.BonusType = BonusType;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], BonusType.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Company, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", Company)
], BonusType.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], BonusType.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], BonusType.prototype, "mode", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], BonusType.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)("text", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "date", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "weekDays", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "holidays", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], BonusType.prototype, "intervals", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "minDuration", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "minDurationPercent", void 0);
__decorate([
    (0, typeorm_1.Column)("time", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "shiftMustStartBefore", void 0);
__decorate([
    (0, typeorm_1.Column)("boolean", { default: true }),
    __metadata("design:type", Boolean)
], BonusType.prototype, "taxFree", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "taxFreeUpToRate", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], BonusType.prototype, "continuedPay", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: BonusCompType.ModifiedHourlyRate }),
    __metadata("design:type", String)
], BonusType.prototype, "compType", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "maxPercent", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "defaultPercent", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "fixedHourlyRateMax", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "fixedHourlyRateDefault", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "fixedAmountMax", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "fixedAmountDefault", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => BonusTypeOverride, (override) => override.subject, { eager: true, cascade: true }),
    __metadata("design:type", Array)
], BonusType.prototype, "overrides", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], BonusType.prototype, "archived", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "order", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], BonusType.prototype, "legalType", void 0);
exports.BonusType = BonusType = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], BonusType);
let Bonus = class Bonus {
    constructor(init = {}) {
        Object.assign(this, init);
    }
};
exports.Bonus = Bonus;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Bonus.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: false }),
    __metadata("design:type", Number)
], Bonus.prototype, "contractId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Contract, (c) => c.bonuses, { onDelete: "CASCADE" }),
    __metadata("design:type", Contract)
], Bonus.prototype, "contract", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Bonus.prototype, "typeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => BonusType, { onDelete: "CASCADE" }),
    __metadata("design:type", BonusType)
], Bonus.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], Bonus.prototype, "percent", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Number)
], Bonus.prototype, "hourlyRate", void 0);
__decorate([
    (0, typeorm_1.Column)("float", { nullable: true }),
    __metadata("design:type", Number)
], Bonus.prototype, "fixedAmount", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], Bonus.prototype, "positionId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Position, { nullable: true, onDelete: "CASCADE" }),
    __metadata("design:type", Object)
], Bonus.prototype, "position", void 0);
exports.Bonus = Bonus = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Bonus);
let AccountingSalaryConfigBonus = class AccountingSalaryConfigBonus {
    constructor(init = {}) {
        this.taxFree = "";
        this.taxed = "";
        Object.assign(this, init);
    }
};
exports.AccountingSalaryConfigBonus = AccountingSalaryConfigBonus;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBonus.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBonus.prototype, "accountingSalaryConfigId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => AccountingSalaryConfig, { onDelete: "CASCADE" }),
    __metadata("design:type", Object)
], AccountingSalaryConfigBonus.prototype, "accountingSalaryConfig", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBonus.prototype, "bonusTypeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => BonusType, { onDelete: "CASCADE" }),
    __metadata("design:type", BonusType)
], AccountingSalaryConfigBonus.prototype, "bonusType", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfigBonus.prototype, "taxFree", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfigBonus.prototype, "taxed", void 0);
exports.AccountingSalaryConfigBonus = AccountingSalaryConfigBonus = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Index)(["accountingSalaryConfigId", "bonusTypeId"], { unique: true }),
    __metadata("design:paramtypes", [Object])
], AccountingSalaryConfigBonus);
let BenefitType = class BenefitType {
    constructor(init = {}) {
        this.name = "";
        this.archived = false;
        this.includeInMinimumWageComparison = false;
        this.includeInBonusPayments = false;
        this.taxFree = false;
        this.order = 0;
        Object.assign(this, init);
    }
};
exports.BenefitType = BenefitType;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], BenefitType.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Company, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", Company)
], BenefitType.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], BenefitType.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], BenefitType.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], BenefitType.prototype, "archived", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], BenefitType.prototype, "includeInMinimumWageComparison", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], BenefitType.prototype, "includeInBonusPayments", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], BenefitType.prototype, "taxFree", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Number)
], BenefitType.prototype, "month", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], BenefitType.prototype, "order", void 0);
exports.BenefitType = BenefitType = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], BenefitType);
let Benefit = class Benefit {
    constructor(init = {}) {
        Object.assign(this, init);
    }
};
exports.Benefit = Benefit;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Benefit.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: false }),
    __metadata("design:type", Number)
], Benefit.prototype, "contractId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Contract, (c) => c.salaries, { onDelete: "CASCADE" }),
    __metadata("design:type", Contract)
], Benefit.prototype, "contract", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Benefit.prototype, "typeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => BenefitType, { onDelete: "CASCADE" }),
    __metadata("design:type", BenefitType)
], Benefit.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)("float"),
    __metadata("design:type", Number)
], Benefit.prototype, "amount", void 0);
exports.Benefit = Benefit = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Benefit);
let AccountingSalaryConfigBenefit = class AccountingSalaryConfigBenefit {
    constructor(init = {}) {
        Object.assign(this, init);
    }
};
exports.AccountingSalaryConfigBenefit = AccountingSalaryConfigBenefit;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBenefit.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBenefit.prototype, "accountingSalaryConfigId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => AccountingSalaryConfig, { onDelete: "CASCADE" }),
    __metadata("design:type", Object)
], AccountingSalaryConfigBenefit.prototype, "accountingSalaryConfig", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBenefit.prototype, "benefitTypeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => BenefitType, { onDelete: "CASCADE" }),
    __metadata("design:type", BenefitType)
], AccountingSalaryConfigBenefit.prototype, "benefitType", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], AccountingSalaryConfigBenefit.prototype, "wageTypeNumber", void 0);
exports.AccountingSalaryConfigBenefit = AccountingSalaryConfigBenefit = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], AccountingSalaryConfigBenefit);
let TimeLogDevice = class TimeLogDevice {
    constructor(init = {}) {
        this.description = "";
        this.connectionCode = "";
        this.displaySchedule = true;
        this.displayUpcoming = true;
        this.displayActive = true;
        this.colorScheme = "system";
        this.legacy = false;
        this.appVersion = null;
        Object.assign(this, init);
    }
};
exports.TimeLogDevice = TimeLogDevice;
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Company, { onDelete: "CASCADE" }),
    (0, class_transformer_1.Type)(() => Company),
    __metadata("design:type", Company)
], TimeLogDevice.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], TimeLogDevice.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "clientId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => entities_1.APIClient, { onDelete: "CASCADE", nullable: true }),
    __metadata("design:type", entities_1.APIClient)
], TimeLogDevice.prototype, "client", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "authTokenId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => entities_1.APIAuthToken, { onDelete: "SET NULL", nullable: true }),
    __metadata("design:type", entities_1.APIAuthToken)
], TimeLogDevice.prototype, "authToken", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { default: [] }),
    __metadata("design:type", Array)
], TimeLogDevice.prototype, "filters", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "image", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "connectionCode", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "vendor", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "model", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "userAgent", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], TimeLogDevice.prototype, "lastActive", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], TimeLogDevice.prototype, "displaySchedule", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], TimeLogDevice.prototype, "displayUpcoming", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: true }),
    __metadata("design:type", Boolean)
], TimeLogDevice.prototype, "displayActive", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "system" }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "colorScheme", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], TimeLogDevice.prototype, "legacy", void 0);
__decorate([
    (0, typeorm_1.Column)("text", { nullable: true }),
    __metadata("design:type", Object)
], TimeLogDevice.prototype, "appVersion", void 0);
exports.TimeLogDevice = TimeLogDevice = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], TimeLogDevice);
function timeLogActionLabel(action) {
    switch (action) {
        case "startShift":
            return "Schichtbeginn";
        case "endShift":
            return "Schichtende";
        case "startBreak":
            return "Beginn Pause";
        case "endBreak":
            return "Ende Pause";
    }
}
function timeLogActionIcon(action) {
    switch (action) {
        case "startShift":
            return "play-circle";
        case "endShift":
            return "stop-circle";
        case "startBreak":
        case "endBreak":
            return "coffee";
    }
}
let TimeLogEvent = class TimeLogEvent {
    constructor(init = {}) {
        this.source = "terminal";
        this.status = "pending";
        Object.assign(this, init);
    }
};
exports.TimeLogEvent = TimeLogEvent;
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "action", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "terminal" }),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "source", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "deviceId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => TimeLogDevice, { onDelete: "SET NULL", nullable: true }),
    __metadata("design:type", TimeLogDevice)
], TimeLogEvent.prototype, "device", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], TimeLogEvent.prototype, "employeeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Employee, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], TimeLogEvent.prototype, "employee", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Number)
], TimeLogEvent.prototype, "positionId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Position, { onDelete: "CASCADE", nullable: true }),
    __metadata("design:type", Position)
], TimeLogEvent.prototype, "position", void 0);
__decorate([
    (0, typeorm_1.Index)("IDX_time_log_event_time_entry_id", { where: '"timeEntryId" IS NOT NULL' }),
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "timeEntryId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => TimeEntry, { onDelete: "CASCADE", nullable: true }),
    __metadata("design:type", TimeEntry)
], TimeLogEvent.prototype, "timeEntry", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], TimeLogEvent.prototype, "time", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "rejectedReason", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], TimeLogEvent.prototype, "location", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "image", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "comment", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], TimeLogEvent.prototype, "meals", void 0);
exports.TimeLogEvent = TimeLogEvent = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], TimeLogEvent);
exports.noteTypes = [
    "textNote", // contains only text with formatting options like bulleted lists, bold, italic
    "taskList", // contains only a checklist with checkboxes, text cannot be formatted
];
let Note = class Note {
    constructor(init = {}) {
        this.content = "";
        this.type = "textNote";
        Object.assign(this, init);
    }
};
exports.Note = Note;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Note.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], Note.prototype, "employeeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Employee, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], Note.prototype, "employee", void 0);
__decorate([
    (0, typeorm_1.Column)("text"),
    __metadata("design:type", String)
], Note.prototype, "content", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Note.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({ type: "timestamptz" }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Note.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({ type: "timestamptz" }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Note.prototype, "updated", void 0);
exports.Note = Note = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Unique)(["employeeId", "type"]),
    __metadata("design:paramtypes", [Object])
], Note);
function stripSensitiveData(e) {
    e.address = "";
    e.birthCity = "";
    e.birthCountry = "";
    e.birthName = "";
    e.birthday = "";
    e.city = "";
    e.email = "";
    e.phone = "";
    e.phone2 = "";
    e.notes = "";
    e.postalCode = "";
    e.socialSecurityNumber = "";
    e.taxId = "";
    e.gender = undefined;
    e.nationality = "";
    e.contracts.forEach((c) => {
        c.benefits = [];
        c.benefitsOld = [];
        c.salaries = [];
        c.bonusHoliday = 0;
        c.bonusNight1 = 0;
        c.bonusNight2 = 0;
        c.bonusSpecial = 0;
        c.bonusSunday = 0;
        c.bonuses = [];
        c.christmasBonus = 0;
        c.comment = "";
        c.enableSFNLedger = false;
        c.maxSalary = 0;
        c.sfnAdvance = 0;
        c.vacationBonus = 0;
    });
    e.invite = e.invite ? { ...e.invite, id: "" } : null;
}
function stripSensitiveDataForManageApp(e) {
    e.invite = e.invite ? { ...e.invite, id: "" } : null;
}
//# sourceMappingURL=model.js.map